// import mpmap from "../images/mpmap.png";
const SectorData = [
  {
    state_id: "1",
    sortname: "Mp",
    state_name: "Madhyapradesh",
   
    budget: [
      {
        Art_and_culture_budgetNo: "54356",
        Agriculture_budgetNo: "16,784 sCr.",
        Education_budgetNo: "30,109 Cr.",
        Economic_budgetNo: "30,10",
        Health_budgetNo: "13,903 Cr.",
        Rural_budgetNo: "14,313 Cr.",
        Women_budgetNo: "1456",
        Science_budgetNo: "3647",
        Waterresource_budgetNo: "301896",
        Transport_budgetNo: "6,978 Cr.",
        Watersanitation_budgetNo: "8,657 Cr.",
        Homeaffair_budgetNo: "30,109",
        statename: "Madhyapradesh",
        Discription:
          "Madhya Pradesh is a state in central India. Its capital is Bhopal, and the largest city is Indore, with Jabalpur, Ujjain, Gwalior, Sagar, Satna, Narmadapuram, Shahdol, Rewa and Morena being the other major cities... ",
        image: "images/mpmap.png",
        image2: "images/mplogo.png",
        alt: "MP"
      },
    ],
    District: [
      {
        District_id: "1",
        District_name: "khargone",
        satate_id: "1",
        Art_and_culture_DbudgetNo: "578886",
        Agriculture_DbudgetNo: "78289",
        District_info:
          "Khargone district is situated on the south west border of Madhya Pradesh.  Its area is approximately 8030 sq. Km. Dhar, Indore and Dewas are located in the North side of this district. Maharashtra in the South, Khandwa & Burhanpur in the East and Barwani in the West. Located in the central part of the Narmada Valley, north of this district there are Vindhyachal and Satpura mountain ranges in the south.",
        area: "6477.89 Sq. Km.",
        population: "18,72,413",
        language: "Hindi, Nimadi, Gujrati, Bareli",
        Villages: "1421",
          tehsil: [
          /* -----------------------------------------------------------*/
          {
            tehsil_id: "1",
            tehsil_name: "Barwaha",
            Art_and_culture_TbudgetNo: "98989",
        Agriculture_TbudgetNo: "567893",
            District_id: "1",
            villages: [
              {
                village_id: "1",
                village_name: "Agar Gaon",
                tehsil_id: "1",
                village_budget: "12764",
              },
              {
                village_id: "2",
                village_name: "Agarwara",
                tehsil_id: "1",
                village_budget: "12364",
              },
              {
                village_id: "3",
                village_name: "Akaya",
                tehsil_id: "1",
                village_budget: "12364",
              },
              {
                village_id: "4",
                village_name: "Ali Bujurg",
                tehsil_id: "1",
                village_budget: "12364",
              },
              {
                village_id: "5",
                village_name: "Ali Khurd",
                tehsil_id: "1",
                village_budget: "15364",
              },
              {
                village_id: "6",
                village_name: "Amalatha",
                tehsil_id: "1",
                village_budget: "15364",
              },
              {
                village_id: "7",
                village_name: "Amarpura",
                tehsil_id: "1",
                village_budget: "12764",
              },
              {
                village_id: "8",
                village_name: "Amba",
                tehsil_id: "1",
                village_budget: "12364",
              },
              {
                village_id: "9",
                village_name: "Amjrud",
                tehsil_id: "1",
                village_budget: "12364",
              },
              {
                village_id: "10",
                village_name: "Aroda",
                tehsil_id: "1",
                village_budget: "12364",
              },
              {
                village_id: "11",
                village_name: "Arri",
                tehsil_id: "1",
                village_budget: "15364",
              },
              {
                village_id: "12",
                village_name: "Arsi Mirjapura",
                tehsil_id: "1",
                village_budget: "15364",
              },
              {
                village_id: "13",
                village_name: "Astaria",
                tehsil_id: "1",
                village_budget: "12764",
              },
              {
                village_id: "14",
                village_name: "Atarsumba",
                tehsil_id: "1",
                village_budget: "12364",
              },
              {
                village_id: "15",
                village_name: "Athwan",
                tehsil_id: "1",
                village_budget: "12364",
              },
              {
                village_id: "16",
                village_name: "Baddiya Khurd",
                tehsil_id: "1",
                village_budget: "12364",
              },
              {
                village_id: "17",
                village_name: "Badel",
                tehsil_id: "1",
                village_budget: "15364",
              },
              {
                village_id: "18",
                village_name: "Badgaon",
                tehsil_id: "1",
                village_budget: "15364",
              },
              {
                village_id: "19",
                village_name: "Badiyabujurag",
                tehsil_id: "1",
                village_budget: "15364",
              },
              {
                village_id: "20",
                village_name: "Badud",
                tehsil_id: "1",
                village_budget: "15364",
              },
            ],
          },
          {
            tehsil_id: "2",
            tehsil_name: "Bhagwanpura",
            District_id: "1",
            villages: [
              {
                village_id: "1",
                village_name: "Amba",
                tehsil_id: "2",
                village_budget: "12964",
              },
              {
                village_id: "2",
                village_name: "Ambakheda",
                tehsil_id: "2",
                village_budget: "12364",
              },
              {
                village_id: "3",
                village_name: "Amlyapani",
                tehsil_id: "2",
                village_budget: "12364",
              },
              {
                village_id: "4",
                village_name: "Anakwadi",
                tehsil_id: "2",
                village_budget: "12364",
              },
              {
                village_id: "5",
                village_name: "Anjengaon",
                tehsil_id: "2",
                village_budget: "15364",
              },
              {
                village_id: "6",
                village_name: "Badi",
                tehsil_id: "2",
                village_budget: "15364",
              },
              {
                village_id: "7",
                village_name: "Badi Bujurg",
                tehsil_id: "2",
                village_budget: "12764",
              },
              {
                village_id: "8",
                village_name: "Badi khurd",
                tehsil_id: "2",
                village_budget: "12364",
              },
              {
                village_id: "9",
                village_name: "Badya",
                tehsil_id: "2",
                village_budget: "12364",
              },
              {
                village_id: "10",
                village_name: "Bagadara",
                tehsil_id: "2",
                village_budget: "12364",
              },
              {
                village_id: "11",
                village_name: "Bagdari",
                tehsil_id: "2",
                village_budget: "15364",
              },
              {
                village_id: "12",
                village_name: "Bahadarpura",
                tehsil_id: "2",
                village_budget: "15364",
              },
              {
                village_id: "13",
                village_name: "Balkhad Bujurg",
                tehsil_id: "2",
                village_budget: "12764",
              },
              {
                village_id: "14",
                village_name: "Balkhad khurd",
                tehsil_id: "2",
                village_budget: "12364",
              },
              {
                village_id: "15",
                village_name: "Balwadi",
                tehsil_id: "2",
                village_budget: "12364",
              },
              {
                village_id: "16",
                village_name: "Banganga",
                tehsil_id: "2",
                village_budget: "12364",
              },
              {
                village_id: "17",
                village_name: "Banher",
                tehsil_id: "2",
                village_budget: "15364",
              },
              {
                village_id: "18",
                village_name: "Banhur",
                tehsil_id: "2",
                village_budget: "15364",
              },
              {
                village_id: "19",
                village_name: "Banskhedi",
                tehsil_id: "2",
                village_budget: "15364",
              },
              {
                village_id: "20",
                village_name: "Bawli",
                tehsil_id: "2",
                village_budget: "15364",
              },
            ],
          },
          {
            tehsil_id: "3",
            tehsil_name: "Bhikangaon",
            District_id: "1",
            villages: [
              {
                village_id: "1",
                village_name: "Aawaliya",
                tehsil_id: "3",
                village_budget: "12364",
              },
              {
                village_id: "2",
                village_name: "Ahir Kheda",
                tehsil_id: "3",
                village_budget: "12764",
              },
              {
                village_id: "3",
                village_name: "Akhapura",
                tehsil_id: "3",
                village_budget: "12364",
              },
              {
                village_id: "4",
                village_name: "Aman Khedi",
                tehsil_id: "3",
                village_budget: "12364",
              },
              {
                village_id: "5",
                village_name: "Andad",
                tehsil_id: "3",
                village_budget: "15364",
              },
              {
                village_id: "6",
                village_name: "Anjangaon",
                tehsil_id: "3",
                village_budget: "15364",
              },
              {
                village_id: "7",
                village_name: "Aurangpura",
                tehsil_id: "3",
                village_budget: "12764",
              },
              {
                village_id: "8",
                village_name: "Badgaon",
                tehsil_id: "3",
                village_budget: "12364",
              },
              {
                village_id: "9",
                village_name: "Badiya",
                tehsil_id: "3",
                village_budget: "12364",
              },
              {
                village_id: "10",
                village_name: "Balkhadya",
                tehsil_id: "3",
                village_budget: "12364",
              },
              {
                village_id: "11",
                village_name: "Bamnala",
                tehsil_id: "3",
                village_budget: "15364",
              },
              {
                village_id: "12",
                village_name: "Banjari",
                tehsil_id: "3",
                village_budget: "12764",
              },
              {
                village_id: "13",
                village_name: "Banjhar",
                tehsil_id: "3",
                village_budget: "12764",
              },
              {
                village_id: "14",
                village_name: "Basantpura",
                tehsil_id: "3",
                village_budget: "12364",
              },
              {
                village_id: "15",
                village_name: "Bhagur",
                tehsil_id: "3",
                village_budget: "12364",
              },
              {
                village_id: "16",
                village_name: "Bhagwanpura",
                tehsil_id: "3",
                village_budget: "12364",
              },
              {
                village_id: "17",
                village_name: "Bhatalpura",
                tehsil_id: "3",
                village_budget: "15364",
              },
              {
                village_id: "18",
                village_name: "Bhikangaon",
                tehsil_id: "3",
                village_budget: "15364",
              },
              {
                village_id: "19",
                village_name: "Bhopada",
                tehsil_id: "3",
                village_budget: "15364",
              },
              {
                village_id: "20",
                village_name: "Bhopatpura",
                tehsil_id: "3",
                village_budget: "15364",
              },
            ],
          },
          {
            tehsil_id: "4",
            tehsil_name: "Gogaon",
            District_id: "1",
            villages: [
              { village_id: "1", village_name: "Agarbai", tehsil_id: "4" },
              { village_id: "2", village_name: "Amba Deola", tehsil_id: "4" },
              {
                village_id: "3",
                village_name: "Atarli",
                tehsil_id: "4",
                village_budget: "12364",
              },
              {
                village_id: "4",
                village_name: "Awali Bistan",
                tehsil_id: "4",
                village_budget: "12364",
              },
              {
                village_id: "5",
                village_name: "Badgaon Nagjhiri",
                tehsil_id: "4",
                village_budget: "15464",
              },
              {
                village_id: "6",
                village_name: "Badgaon Signur",
                tehsil_id: "4",
                village_budget: "15464",
              },
              {
                village_id: "7",
                village_name: "Baijapura Surpala",
                tehsil_id: "4",
                village_budget: "12764",
              },
              {
                village_id: "8",
                village_name: "Balabad",
                tehsil_id: "4",
                village_budget: "12464",
              },
              {
                village_id: "9",
                village_name: "Balapur",
                tehsil_id: "4",
                village_budget: "12464",
              },
              {
                village_id: "10",
                village_name: "Balgaon",
                tehsil_id: "4",
                village_budget: "12464",
              },
              {
                village_id: "11",
                village_name: "Behrampura ",
                tehsil_id: "4",
                village_budget: "15464",
              },
              {
                village_id: "12",
                village_name: "Bheelkheda",
                tehsil_id: "4",
                village_budget: "12764",
              },
              {
                village_id: "13",
                village_name: "Bid",
                tehsil_id: "4",
                village_budget: "12764",
              },
              {
                village_id: "14",
                village_name: "Bijalgaon khurd",
                tehsil_id: "4",
                village_budget: "12464",
              },
              {
                village_id: "15",
                village_name: "Bilali",
                tehsil_id: "4",
                village_budget: "12464",
              },
              {
                village_id: "16",
                village_name: "Bilkheda",
                tehsil_id: "4",
                village_budget: "12464",
              },
              {
                village_id: "17",
                village_name: "Bistan",
                tehsil_id: "4",
                village_budget: "15464",
              },
              {
                village_id: "18",
                village_name: "Borgoan Bilkheda",
                tehsil_id: "4",
                village_budget: "15464",
              },
              {
                village_id: "19",
                village_name: "Budaya",
                tehsil_id: "4",
                village_budget: "15464",
              },
              {
                village_id: "20",
                village_name: "Chari",
                tehsil_id: "4",
                village_budget: "15464",
              },
            ],
          },
          {
            tehsil_id: "5",
            tehsil_name: "Jhiranya",
            District_id: "1",
            villages: [
              { village_id: "1", village_name: "Abhapuri", tehsil_id: "5" },
              {
                village_id: "2",
                village_name: "Abhapuri NanKhodi",
                tehsil_id: "5",
              },
              {
                village_id: "3",
                village_name: "Agasya",
                tehsil_id: "5",
                village_budget: "12365",
              },
              {
                village_id: "4",
                village_name: "Ambadochar",
                tehsil_id: "5",
                village_budget: "12365",
              },
              {
                village_id: "5",
                village_name: "Ardla ",
                tehsil_id: "5",
                village_budget: "15565",
              },
              {
                village_id: "6",
                village_name: "Badi",
                tehsil_id: "5",
                village_budget: "15565",
              },
              {
                village_id: "7",
                village_name: "Bagdari",
                tehsil_id: "5",
                village_budget: "12765",
              },
              {
                village_id: "8",
                village_name: "Balkhad",
                tehsil_id: "5",
                village_budget: "12565",
              },
              {
                village_id: "9",
                village_name: "Baykheda",
                tehsil_id: "5",
                village_budget: "12565",
              },
              {
                village_id: "10",
                village_name: "Bedchha",
                tehsil_id: "5",
                village_budget: "12565",
              },
              {
                village_id: "11",
                village_name: "Bedhanaya Khurd",
                tehsil_id: "5",
                village_budget: "15565",
              },
              {
                village_id: "12",
                village_name: "Bedhanya Buzurg",
                tehsil_id: "5",
                village_budget: "12765",
              },
              {
                village_id: "13",
                village_name: "Bhadlen",
                tehsil_id: "5",
                village_budget: "12765",
              },
              {
                village_id: "14",
                village_name: "Bharadi",
                tehsil_id: "5",
                village_budget: "12565",
              },
              {
                village_id: "15",
                village_name: "Bhavsingh pura",
                tehsil_id: "5",
                village_budget: "12565",
              },
              {
                village_id: "16",
                village_name: "Bilkhed",
                tehsil_id: "5",
                village_budget: "12565",
              },
              {
                village_id: "17",
                village_name: "Bondranya",
                tehsil_id: "5",
                village_budget: "15565",
              },
              {
                village_id: "18",
                village_name: "Borkheda",
                tehsil_id: "5",
                village_budget: "15565",
              },
              {
                village_id: "19",
                village_name: "Borwal",
                tehsil_id: "5",
                village_budget: "15565",
              },
              {
                village_id: "20",
                village_name: "Brahman puri",
                tehsil_id: "5",
                village_budget: "15565",
              },
            ],
          },
          {
            tehsil_id: "6",
            tehsil_name: "Kasrawad",
            District_id: "1",
            villages: [
              {
                village_id: "1",
                village_name: "Adalpura",
                tehsil_id: "6",
                village_budget: "12365",
              },
              {
                village_id: "2",
                village_name: "Aghanwan",
                tehsil_id: "6",
                village_budget: "12365",
              },
              {
                village_id: "3",
                village_name: "Ahilyapura",
                tehsil_id: "6",
                village_budget: "12366",
              },
              {
                village_id: "4",
                village_name: "Akbarpura",
                tehsil_id: "6",
                village_budget: "12366",
              },
              {
                village_id: "5",
                village_name: "Amlatha",
                tehsil_id: "6",
                village_budget: "1666",
              },
              {
                village_id: "6",
                village_name: "Aurangapura",
                tehsil_id: "6",
                village_budget: "1666",
              },
              {
                village_id: "7",
                village_name: "Aurangpura",
                tehsil_id: "6",
                village_budget: "12766",
              },
              {
                village_id: "8",
                village_name: "Awalya",
                tehsil_id: "6",
                village_budget: "1166",
              },
              {
                village_id: "9",
                village_name: "Awarkachh",
                tehsil_id: "6",
                village_budget: "12666",
              },
              {
                village_id: "10",
                village_name: "Badgaon",
                tehsil_id: "6",
                village_budget: "12666",
              },
              {
                village_id: "11",
                village_name: "Badi",
                tehsil_id: "6",
                village_budget: "1666",
              },
              {
                village_id: "12",
                village_name: "Badya",
                tehsil_id: "6",
                village_budget: "12766",
              },
              {
                village_id: "13",
                village_name: "Bahadarpura",
                tehsil_id: "6",
                village_budget: "12766",
              },
              {
                village_id: "14",
                village_name: "Bahaderpura",
                tehsil_id: "6",
                village_budget: "12666",
              },
              {
                village_id: "15",
                village_name: "Baigandi",
                tehsil_id: "6",
                village_budget: "12666",
              },
              {
                village_id: "16",
                village_name: "Bairagarh",
                tehsil_id: "6",
                village_budget: "12666",
              },
              {
                village_id: "17",
                village_name: "Bajitpura",
                tehsil_id: "6",
                village_budget: "1666",
              },
              {
                village_id: "18",
                village_name: "Balakwada",
                tehsil_id: "6",
                village_budget: "1666",
              },
              {
                village_id: "19",
                village_name: "Balgaon",
                tehsil_id: "6",
                village_budget: "1666",
              },
              {
                village_id: "20",
                village_name: "Balkhad",
                tehsil_id: "6",
                village_budget: "1666",
              },
            ],
          },
          {
            tehsil_id: "7",
            tehsil_name: "Khargone",
            District_id: "1",
            villages: [
              {
                village_id: "1",
                village_name: "Aarampura",
                tehsil_id: "7",
                village_budget: "12366",
              },
              {
                village_id: "2",
                village_name: "Adampura",
                tehsil_id: "7",
                village_budget: "12366",
              },
              {
                village_id: "3",
                village_name: "Aghawan",
                tehsil_id: "7",
                village_budget: "1237",
              },
              {
                village_id: "4",
                village_name: "Akawalya",
                tehsil_id: "7",
                village_budget: "1237",
              },
              {
                village_id: "5",
                village_name: "Asangaon",
                tehsil_id: "7",
                village_budget: "17",
              },
              {
                village_id: "6",
                village_name: "Awali",
                tehsil_id: "7",
                village_budget: "17",
              },
              {
                village_id: "7",
                village_name: "Badya",
                tehsil_id: "7",
                village_budget: "1277",
              },
              {
                village_id: "8",
                village_name: "Baghwa",
                tehsil_id: "7",
                village_budget: "127",
              },
              {
                village_id: "9",
                village_name: "Bagud",
                tehsil_id: "7",
                village_budget: "127",
              },
              {
                village_id: "10",
                village_name: "Bahadurpura",
                tehsil_id: "7",
                village_budget: "127",
              },
              {
                village_id: "11",
                village_name: "Baijapura",
                tehsil_id: "7",
                village_budget: "17",
              },
              {
                village_id: "12",
                village_name: "Balwadi Soniipura",
                tehsil_id: "7",
                village_budget: "1277",
              },
              {
                village_id: "13",
                village_name: "Banjari",
                tehsil_id: "7",
                village_budget: "1277",
              },
              {
                village_id: "14",
                village_name: "Bardiya",
                tehsil_id: "7",
                village_budget: "127",
              },
              {
                village_id: "15",
                village_name: "Barkheda",
                tehsil_id: "7",
                village_budget: "127",
              },
              {
                village_id: "16",
                village_name: "Barud",
                tehsil_id: "7",
                village_budget: "127",
              },
              {
                village_id: "17",
                village_name: "Bediyapura",
                tehsil_id: "7",
                village_budget: "17",
              },
              {
                village_id: "18",
                village_name: "Belmar",
                tehsil_id: "7",
                village_budget: "17",
              },
              {
                village_id: "19",
                village_name: "Bhamori Buzurg",
                tehsil_id: "7",
                village_budget: "17",
              },
              {
                village_id: "20",
                village_name: "Bhamori",
                tehsil_id: "7",
                village_budget: "17",
              },
            ],
          },
          {
            tehsil_id: "8",
            tehsil_name: "Maheshwar",
            District_id: "1",
            villages: [
              { village_id: "1", village_name: "Ahilypura", tehsil_id: "8" },
              { village_id: "2", village_name: "Ajitpura", tehsil_id: "8" },
              {
                village_id: "3",
                village_name: "Akhipura",
                tehsil_id: "8",
                village_budget: "11764",
              },
              {
                village_id: "4",
                village_name: "Ashapur",
                tehsil_id: "8",
                village_budget: "13764",
              },
              {
                village_id: "5",
                village_name: "Asukhedi",
                tehsil_id: "8",
                village_budget: "14764",
              },
              {
                village_id: "6",
                village_name: "Awalya",
                tehsil_id: "8",
                village_budget: "15764",
              },
              {
                village_id: "7",
                village_name: "Bablai",
                tehsil_id: "8",
                village_budget: "10764",
              },
              {
                village_id: "8",
                village_name: "Bada",
                tehsil_id: "8",
                village_budget: "10764",
              },
              {
                village_id: "9",
                village_name: "Badadiya surta",
                tehsil_id: "8",
                village_budget: "10764",
              },
              {
                village_id: "10",
                village_name: "Baddiya",
                tehsil_id: "8",
                village_budget: "10764",
              },
              {
                village_id: "11",
                village_name: "Badwel",
                tehsil_id: "8",
                village_budget: "10764",
              },
              {
                village_id: "12",
                village_name: "Badwi",
                tehsil_id: "8",
                village_budget: "10764",
              },
              {
                village_id: "13",
                village_name: "Bagkeria khedi",
                tehsil_id: "8",
                village_budget: "10764",
              },
              {
                village_id: "14",
                village_name: "Bagsomakhedi",
                tehsil_id: "8",
                village_budget: "10764",
              },
              {
                village_id: "15",
                village_name: "Bahegawan",
                tehsil_id: "8",
                village_budget: "10764",
              },
              {
                village_id: "16",
                village_name: "Bakaner",
                tehsil_id: "8",
                village_budget: "10764",
              },
              {
                village_id: "17",
                village_name: "Balasgaon",
                tehsil_id: "8",
                village_budget: "10764",
              },
              {
                village_id: "18",
                village_name: "Bandera",
                tehsil_id: "8",
                village_budget: "10764",
              },
              {
                village_id: "19",
                village_name: "Banjari",
                tehsil_id: "8",
                village_budget: "10764",
              },
              {
                village_id: "20",
                village_name: "Bardiya",
                tehsil_id: "8",
                village_budget: "10764",
              },
            ],
          },
          {
            tehsil_id: "9",
            tehsil_name: "Segaon",
            District_id: "1",
            villages: [
              { village_id: "1", village_name: "Achhalwadi", tehsil_id: "9" },
              { village_id: "2", village_name: "Badha", tehsil_id: "9" },
              { village_id: "3", village_name: "Baneehar", tehsil_id: "9" },
              { village_id: "4", village_name: "Bhadwali", tehsil_id: "9" },
              { village_id: "5", village_name: "Bhikharkhedi", tehsil_id: "9" },
              { village_id: "6", village_name: "Birla", tehsil_id: "9" },
              { village_id: "7", village_name: "Bori", tehsil_id: "9" },
              { village_id: "8", village_name: "Chandawad", tehsil_id: "9" },
              { village_id: "9", village_name: "Chhipeepura", tehsil_id: "9" },
              { village_id: "10", village_name: "Chichgarh", tehsil_id: "9" },
              { village_id: "11", village_name: "Chichli", tehsil_id: "9" },
              { village_id: "12", village_name: "Dalki", tehsil_id: "9" },
              { village_id: "13", village_name: "Damkheda", tehsil_id: "9" },
              { village_id: "14", village_name: "Dasnawal", tehsil_id: "9" },
              { village_id: "15", village_name: "Deoli", tehsil_id: "9" },
              { village_id: "16", village_name: "Domwada", tehsil_id: "9" },
              { village_id: "17", village_name: "Gandhawad", tehsil_id: "9" },
              { village_id: "18", village_name: "Gatlakhedi", tehsil_id: "9" },
              { village_id: "19", village_name: "Golpura", tehsil_id: "9" },
              { village_id: "20", village_name: "Golwadi", tehsil_id: "9" },
              { village_id: "21", village_name: "Gyaspura", tehsil_id: "9" },
              { village_id: "22", village_name: "Hanumantya", tehsil_id: "9" },
            ],
          },

        ],
      },
      {
        District_id: "2",
        District_name: "Barwani",
        District_info: "Barwani is situated on the southern west side of Madhya Pradesh as well as holy river Narmada. District is surrounded by Satpuda (in South) and Vindhyachal (in North) forest ranges.",
        area: "5,427 Sq. Km.",
        population: "13,85,881",
        language: "Hindi And Nimari",
        state_id: "1",
        tehsil: [
          {
            tehsil_id: "1",
            tehsil_name: "Anjad",
            District_id: "2",
            villages: [
              {
                village_id: "1",
                village_name: "Anjad Revenue Area",
                tehsil_id: "1",
                village_budget: "12764",
              },
              {
                village_id: "2",
                village_name: "Awali",
                tehsil_id: "1",
                village_budget: "12364",
              },
              {
                village_id: "3",
                village_name: "Bdgaon",
                tehsil_id: "1",
                village_budget: "12364",
              },
              {
                village_id: "4",
                village_name: "Bajaha",
                tehsil_id: "1",
                village_budget: "12364",
              },
              {
                village_id: "5",
                village_name: "Banjari",
                tehsil_id: "1",
                village_budget: "15364",
              },
              {
                village_id: "6",
                village_name: "Bawadya",
                tehsil_id: "1",
                village_budget: "15364",
              },
              {
                village_id: "7",
                village_name: "Bhamori",
                tehsil_id: "1",
                village_budget: "12764",
              },
              {
                village_id: "8",
                village_name: "Bilwa road",
                tehsil_id: "1",
                village_budget: "12364",
              },
              {
                village_id: "9",
                village_name: "Bilwadeb",
                tehsil_id: "1",
                village_budget: "12364",
              },
              {
                village_id: "10",
                village_name: "Chakeri",
                tehsil_id: "1",
                village_budget: "12364",
              },
              {
                village_id: "11",
                village_name: "Chhaperi",
                tehsil_id: "1",
                village_budget: "15364",
              },
              {
                village_id: "12",
                village_name: "Chhota Barda",
                tehsil_id: "1",
                village_budget: "15364",
              },
              {
                village_id: "13",
                village_name: "Datwada",
                tehsil_id: "1",
                village_budget: "12764",
              },
              {
                village_id: "14",
                village_name: "Fateyapur",
                tehsil_id: "1",
                village_budget: "12364",
              },
              {
                village_id: "15",
                village_name: "Gawala",
                tehsil_id: "1",
                village_budget: "12364",
              },
              {
                village_id: "16",
                village_name: "Golata",
                tehsil_id: "1",
                village_budget: "12364",
              },
              {
                village_id: "17",
                village_name: "Harangaon",
                tehsil_id: "1",
                village_budget: "15364",
              },
              {
                village_id: "18",
                village_name: "Haribad",
                tehsil_id: "1",
                village_budget: "15364",
              },
              {
                village_id: "19",
                village_name: "Jholpipri",
                tehsil_id: "1",
                village_budget: "15364",
              },
              {
                village_id: "20",
                village_name: "Kasharpura",
                tehsil_id: "1",
                village_budget: "15364",
              },

            ],
          },
          {
            tehsil_id: "2",
            tehsil_name: "Thikri",
            District_id: "2",
            villages: [
              {
                village_id: "1",
                village_name: "Abhali",
                tehsil_id: "2",
                village_budget: "22764",
              },
              {
                village_id: "2",
                village_name: "Ajandi",
                tehsil_id: "2",
                village_budget: "22364",
              },
              {
                village_id: "3",
                village_name: "Anantpura",
                tehsil_id: "2",
                village_budget: "22364",
              },
              {
                village_id: "4",
                village_name: "Badsalaya",
                tehsil_id: "2",
                village_budget: "22364",
              },
              {
                village_id: "5",
                village_name: "Baghadi",
                tehsil_id: "2",
                village_budget: "25364",
              },
              {
                village_id: "6",
                village_name: "Balgaon",
                tehsil_id: "2",
                village_budget: "25364",
              },
              {
                village_id: "7",
                village_name: "Bhatgawala",
                tehsil_id: "2",
                village_budget: "22764",
              },
              {
                village_id: "8",
                village_name: "Brahamangaon",
                tehsil_id: "2",
                village_budget: "22364",
              },
              {
                village_id: "9",
                village_name: "Bunderkachh",
                tehsil_id: "2",
                village_budget: "22364",
              },
              {
                village_id: "10",
                village_name: "Chenpura",
                tehsil_id: "2",
                village_budget: "22364",
              },
              {
                village_id: "11",
                village_name: "Chichli",
                tehsil_id: "2",
                village_budget: "25364",
              },
              {
                village_id: "12",
                village_name: "Dabhad",
                tehsil_id: "1",
                village_budget: "15364",
              },
              {
                village_id: "13",
                village_name: "Dawana",
                tehsil_id: "1",
                village_budget: "12764",
              },
              {
                village_id: "14",
                village_name: "Deola",
                tehsil_id: "1",
                village_budget: "12364",
              },
              {
                village_id: "15",
                village_name: "Dewada",
                tehsil_id: "1",
                village_budget: "12364",
              },
              {
                village_id: "16",
                village_name: "Gawala",
                tehsil_id: "1",
                village_budget: "12364",
              },
              {
                village_id: "17",
                village_name: "Ghatti",
                tehsil_id: "1",
                village_budget: "15364",
              },
              {
                village_id: "18",
                village_name: "Ghatwa",
                tehsil_id: "1",
                village_budget: "15364",
              },
              {
                village_id: "19",
                village_name: "Gholanya",
                tehsil_id: "1",
                village_budget: "15364",
              },
              {
                village_id: "20",
                village_name: "Hasankhedi",
                tehsil_id: "1",
                village_budget: "15364",
              },
            ],
          },
          {
            tehsil_id: "3",
            tehsil_name: "Rajpur",
            District_id: "2",
            villages: [
              {
                village_id: "1",
                village_name: "Agalgaon",
                tehsil_id: "3",
                village_budget: "12764",
              },
              {
                village_id: "2",
                village_name: "Atarsanbha",
                tehsil_id: "3",
                village_budget: "12364",
              },
              {
                village_id: "3",
                village_name: "Awalya",
                tehsil_id: "3",
                village_budget: "12364",
              },
              {
                village_id: "4",
                village_name: "Baghad",
                tehsil_id: "3",
                village_budget: "12364",
              },
              {
                village_id: "5",
                village_name: "Bajad",
                tehsil_id: "3",
                village_budget: "15364",
              },
              {
                village_id: "6",
                village_name: "Bakwadi",
                tehsil_id: "3",
                village_budget: "15364",
              },
              {
                village_id: "7",
                village_name: "Balsamund",
                tehsil_id: "3",
                village_budget: "12764",
              },
              {
                village_id: "8",
                village_name: "Bhagsur",
                tehsil_id: "3",
                village_budget: "12364",
              },
              {
                village_id: "9",
                village_name: "Bhami",
                tehsil_id: "3",
                village_budget: "12364",
              },
              {
                village_id: "10",
                village_name: "Bhilkheda",
                tehsil_id: "3",
                village_budget: "12364",
              },
              {
                village_id: "11",
                village_name: "Bhorwada",
                tehsil_id: "3",
                village_budget: "15364",
              },
              {
                village_id: "12",
                village_name: "Bhulgaon",
                tehsil_id: "3",
                village_budget: "15364",
              },
              {
                village_id: "13",
                village_name: "bilwani",
                tehsil_id: "3",
                village_budget: "12764",
              },
              {
                village_id: "14",
                village_name: "Bobalwadi",
                tehsil_id: "3",
                village_budget: "12364",
              },
              {
                village_id: "15",
                village_name: "Borali",
                tehsil_id: "3",
                village_budget: "12364",
              },
              {
                village_id: "16",
                village_name: "Budra",
                tehsil_id: "3",
                village_budget: "12364",
              },
              {
                village_id: "17",
                village_name: "Chautariya",
                tehsil_id: "3",
                village_budget: "15364",
              },
              {
                village_id: "18",
                village_name: "chhotiKhargone",
                tehsil_id: "3",
                village_budget: "15364",
              },
              {
                village_id: "19",
                village_name: "Chitawal",
                tehsil_id: "3",
                village_budget: "15364",
              },
              {
                village_id: "20",
                village_name: "Damdami",
                tehsil_id: "3",
                village_budget: "15364",
              },
            ],
          },
          {
            tehsil_id: "4",
            tehsil_name: "Sendhwa",
            District_id: "2",
            villages: [
              { village_id: "1", village_name: "Achhali", tehsil_id: "4", village_budget: "15364", },
              { village_id: "2", village_name: "Ajalgaon", tehsil_id: "4", village_budget: "15364",},
              { village_id: "3", village_name: "Amjiri", tehsil_id: "4", village_budget: "15364",},
              { village_id: "4", village_name: "Badgaon", tehsil_id: "4", village_budget: "15364",},
              { village_id: "5", village_name: "Bakee Urf Goi", tehsil_id: "4", village_budget: "15364",},
              { village_id: "6", village_name: "Bakhatariya", tehsil_id: "4", village_budget: "15364",},
              { village_id: "7", village_name: "Balkhad", tehsil_id: "4", village_budget: "15364",},
              { village_id: "8", village_name: "Bawadad", tehsil_id: "4", village_budget: "15364",},
              { village_id: "9", village_name: "Bhamanya", tehsil_id: "4", village_budget: "15364",},
              { village_id: "10", village_name: "Bhampura", tehsil_id: "4", village_budget: "15364",},
              { village_id: "11", village_name: "Bhawargarh", tehsil_id: "4", village_budget: "15364",},
              { village_id: "12", village_name: "Bhijapur", tehsil_id: "4", village_budget: "15364",},
              { village_id: "13", village_name: "Borli", tehsil_id: "4", village_budget: "15364",},
              { village_id: "14", village_name: "Chachariya Pati", tehsil_id: "4", village_budget: "15364",},
              { village_id: "15", village_name: "Chikhali", tehsil_id: "4", village_budget: "15364",},
              { village_id: "16", village_name: "Chithari", tehsil_id: "4", village_budget: "15364",},
              { village_id: "17", village_name: "Dhaba", tehsil_id: "4", village_budget: "15364",},
              { village_id: "18", village_name: "Dhaanora", tehsil_id: "4", village_budget: "15364",},
              { village_id: "19", village_name: "Dhanori", tehsil_id: "4", village_budget: "15364",},
              { village_id: "20", village_name: "Dhawada", tehsil_id: "4", village_budget: "15364",},
            ],
          },
          {
            tehsil_id: "5",
            tehsil_name: "Niwali",
            District_id: "2",
            villages: [
              { village_id: "1", village_name: "Badgaon", tehsil_id: "5", village_budget: "15364", },
              { village_id: "2", village_name: "Badgaon Urf Bhangeedad", tehsil_id: "5", village_budget: "15364", },
              { village_id: "3", village_name: "Bhensdad", tehsil_id: "5", village_budget: "15364", },
              { village_id: "4", village_name: "Bhoolgaon", tehsil_id: "5", village_budget: "15364", },
              { village_id: "5", village_name: "Bhoorapani", tehsil_id: "5", village_budget: "15364", },
              { village_id: "6", village_name: "Borli", tehsil_id: "5", village_budget: "15364", },
              { village_id: "7", village_name: "Budhgaon", tehsil_id: "5", village_budget: "15364", },
              { village_id: "8", village_name: "Chatli", tehsil_id: "5", village_budget: "15364", },
              { village_id: "9", village_name: "Chichaba", tehsil_id: "5", village_budget: "15364", },
              { village_id: "10", village_name: "Dhanbawardi", tehsil_id: "5", village_budget: "15364", },
              { village_id: "11", village_name: "Diwaniya", tehsil_id: "5", village_budget: "15364", },
              { village_id: "12", village_name: "Dogaliyapani", tehsil_id: "5", village_budget: "15364", },
              { village_id: "13", village_name: "Dondwada", tehsil_id: "5", village_budget: "15364", },
              { village_id: "14", village_name: "Dongalyapani", tehsil_id: "5", village_budget: "15364", },
              { village_id: "15", village_name: "Gawadi", tehsil_id: "5", village_budget: "15364", },
              { village_id: "16", village_name: "Gawali", tehsil_id: "5", village_budget: "15364", },
              { village_id: "17", village_name: "Gawalivan", tehsil_id: "5", village_budget: "15364", },
              { village_id: "18", village_name: "Ghodya Pani", tehsil_id: "5", village_budget: "15364", },
              { village_id: "19", village_name: "Ghodyapani", tehsil_id: "5", village_budget: "15364", },
              { village_id: "20", village_name: "Gondikachali", tehsil_id: "5", village_budget: "15364", },

            ],
          },
          {
            tehsil_id: "6",
            tehsil_name: "Pansemal",
            District_id: "2",
            villages: [
              { village_id: "1", village_name: "Akal Amba", tehsil_id: "6", village_budget: "15364", },
              { village_id: "2", village_name: "Alkhad", tehsil_id: "5", village_budget: "15364", },
              { village_id: "3", village_name: "Alkhad Bada", tehsil_id: "6", village_budget: "15364", },
              { village_id: "4", village_name: "Alkhard Chhota", tehsil_id: "6", village_budget: "15364", },
              { village_id: "5", village_name: "Amba Padaw", tehsil_id: "6", village_budget: "15364", },
              { village_id: "6", village_name: "Amda", tehsil_id: "6", village_budget: "15364", },
              { village_id: "7", village_name: "Amjiri", tehsil_id: "6", village_budget: "15364", },
              { village_id: "8", village_name: "Amilya Pani", tehsil_id: "6", village_budget: "15364", },
              { village_id: "9", village_name: "Babultad", tehsil_id: "6", village_budget: "15364", },
              { village_id: "10", village_name: "Baljiri", tehsil_id: "6", village_budget: "15364", },
              { village_id: "11", village_name: "Bandhara Bujurg", tehsil_id: "6", village_budget: "15364", },
              { village_id: "12", village_name: "Bandhara khurd", tehsil_id: "6", village_budget: "15364", },
              { village_id: "13", village_name: "Bandiyasemal", tehsil_id: "6", village_budget: "15364", },
              { village_id: "14", village_name: "Bandryabad", tehsil_id: "6", village_budget: "15364", },
              { village_id: "15", village_name: "Banjardipardwa", tehsil_id: "6", village_budget: "15364", },
              { village_id: "16", village_name: "Baygore", tehsil_id: "6", village_budget: "15364", },
              { village_id: "17", village_name: "Behdiya", tehsil_id: "6", village_budget: "15364", },
              { village_id: "18", village_name: "Bhadbhada", tehsil_id: "6", village_budget: "15364", },
              { village_id: "19", village_name: "Bhadgone", tehsil_id: "6", village_budget: "15364", },
              { village_id: "20", village_name: "Bhagal Amba", tehsil_id: "6", village_budget: "15364", },


              
            ],
          },
          {
            tehsil_id: "7",
            tehsil_name: "Varla",
            District_id: "2",
            villages: [
            { village_id: "1", village_name: "Adnadi", tehsil_id: "7", village_budget: "15364", },
            { village_id: "2", village_name: "Ambaaatur", tehsil_id: "7", village_budget: "15364", },
            { village_id: "3", village_name: "Badya Pani", tehsil_id: "7", village_budget: "15364", },
            { village_id: "4", village_name: "Bakharli", tehsil_id: "7", village_budget: "15364", },
            { village_id: "5", village_name: "Balwadi", tehsil_id: "7", village_budget: "15364", },
            { village_id: "6", village_name: "Belghat", tehsil_id: "7", village_budget: "15364", },
            { village_id: "7", village_name: "Bhalabardi", tehsil_id: "7", village_budget: "15364", },
            { village_id: "8", village_name: "Chikhali", tehsil_id: "7", village_budget: "15364", },
            { village_id: "9", village_name: "Chilariya", tehsil_id: "7", village_budget: "15364", },
            { village_id: "10", village_name: "Chirmiriya", tehsil_id: "7", village_budget: "15364", },
            { village_id: "11", village_name: "Deoli", tehsil_id: "7", village_budget: "15364", },
            { village_id: "12", village_name: "Dhamanya", tehsil_id: "7", village_budget: "15364", },
            { village_id: "13", village_name: "Dhawad", tehsil_id: "7", village_budget: "15364", },
            { village_id: "14", village_name: "Dhawali", tehsil_id: "7", village_budget: "15364", },
            { village_id: "15", village_name: "Dudhkheda", tehsil_id: "7", village_budget: "15364", },
            { village_id: "16", village_name: "Dugani", tehsil_id: "7", village_budget: "15364", },
            { village_id: "17", village_name: "Gerughati", tehsil_id: "7", village_budget: "15364", },
            { village_id: "18", village_name: "Ghegaon", tehsil_id: "7", village_budget: "15364", },
            { village_id: "19", village_name: "Hingwa", tehsil_id: "7", village_budget: "15364", },
            { village_id: "20", village_name: "Hol", tehsil_id: "7", village_budget: "15364", },
          
            ],
          },
          {
            tehsil_id: "8",
            tehsil_name: "Barwani",
            District_id: "2",
            villages: [
              { village_id: "1", village_name: "Ajanyapani", tehsil_id: "8", village_budget: "15364", },
              { village_id: "2", village_name: "Amba Pani", tehsil_id: "8", village_budget: "15364", },
              { village_id: "3", village_name: "Amlali", tehsil_id: "8", village_budget: "15364", },
              { village_id: "4", village_name: "Amilya Pani", tehsil_id: "8", village_budget: "15364", },
              { village_id: "5", village_name: "AmlyaPani", tehsil_id: "8", village_budget: "15364", },
              { village_id: "6", village_name: "Awalda", tehsil_id: "8", village_budget: "15364", },
              { village_id: "7", village_name: "Babultad", tehsil_id: "8", village_budget: "15364", },
              { village_id: "8", village_name: "Badgaon", tehsil_id: "8", village_budget: "15364", },
              { village_id: "9", village_name: "Bagud", tehsil_id: "8", village_budget: "15364", },
              { village_id: "10", village_name: "Bajatta Buzurg", tehsil_id: "8", village_budget: "15364", },
              { village_id: "11", village_name: "Bajatta Khurd", tehsil_id: "8", village_budget: "15364", },
              { village_id: "12", village_name: "Balkhad", tehsil_id: "8", village_budget: "15364", },
              { village_id: "13", village_name: "Balkunwa", tehsil_id: "8", village_budget: "15364", },
              { village_id: "14", village_name: "Barukhodra", tehsil_id: "8", village_budget: "15364", },
              { village_id: "15", village_name: "Barwani Khurd", tehsil_id: "8", village_budget: "15364", },
              { village_id: "16", village_name: "Barwani Revenue Area", tehsil_id: "8", village_budget: "15364", },
              { village_id: "17", village_name: "Bawangaja", tehsil_id: "8", village_budget: "15364", },
              { village_id: "18", village_name: "Begalgaon", tehsil_id: "8", village_budget: "15364", },
              { village_id: "19", village_name: "Bhawati", tehsil_id: "8", village_budget: "15364", },
              { village_id: "20", village_name: "Bhikheda", tehsil_id: "8", village_budget: "15364", },
              

            ],
          },
          {
            tehsil_id: "9",
            tehsil_name: "Pati",
            District_id: "2",
            villages: [
              { village_id: "1", village_name: "Ambi", tehsil_id: "9", village_budget: "15364", },
              { village_id: "2", village_name: "Amilya Pani", tehsil_id: "9", village_budget: "15364", },
              { village_id: "3", village_name: "Anjarada", tehsil_id: "9", village_budget: "15364", },
              { village_id: "4", village_name: "Atarsanbha", tehsil_id: "9", village_budget: "15364", },
              { village_id: "5", village_name: "Awali", tehsil_id: "9", village_budget: "15364", },
              { village_id: "6", village_name: "Bada", tehsil_id: "9", village_budget: "15364", },
              { village_id: "7", village_name: "Baidi Falya", tehsil_id: "9", village_budget: "15364", },
              { village_id: "8", village_name: "Bamnali", tehsil_id: "9", village_budget: "15364", },
              { village_id: "9", village_name: "Berada", tehsil_id: "9", village_budget: "15364", },
              { village_id: "10", village_name: "Bhadal", tehsil_id: "9", village_budget: "15364", },
              { village_id: "11", village_name: "Bhaisari", tehsil_id: "9", village_budget: "15364", },
              { village_id: "12", village_name: "Bhanij Kundiya", tehsil_id: "9", village_budget: "15364", },
              { village_id: "13", village_name: "Bokarata", tehsil_id: "9", village_budget: "15364", },
              { village_id: "14", village_name: "Borkhedi", tehsil_id: "9", village_budget: "15364", },
              { village_id: "15", village_name: "Borkund", tehsil_id: "9", village_budget: "15364", },
              { village_id: "16", village_name: "Budi", tehsil_id: "9", village_budget: "15364", },
              { village_id: "17", village_name: "Chakalya", tehsil_id: "9", village_budget: "15364", },
              { village_id: "18", village_name: "Chandan Devi", tehsil_id: "9", village_budget: "15364", },
              { village_id: "19", village_name: "Charpatiya", tehsil_id: "9", village_budget: "15364", },
              { village_id: "20", village_name: "Chervi", tehsil_id: "9", village_budget: "15364", },
            
            ],
          },
        ],
      },
// Khandawa
{
  District_id: "3",
  District_name: "Khandwa",
  District_info: "Khandwa district, formerly known as the East Nimar district, is a district of the Madhya Pradesh state in central India. The city of Khandwa is the administrative headquarters of the district. Other notable towns in the district include Mundi, Harsud, Pandhana and Omkareshwar.",
  area: "5,427 Sq. Km.",
  population: "13,85,881",
  language: "Hindi And Nimari",
  state_id: "1",
  tehsil: [
    {
      tehsil_id: "1",
      tehsil_name: "Khandwa",
      District_id: "3",
      Village_budget:"1002",
      villages: [
        { village_id: "1", village_name: "Amalpura", tehsil_id: "1" ,Village_budget:"1002",},
        { village_id: "2", village_name: "Amoda", tehsil_id: "1",Village_budget:"1002", },
        { village_id: "3", village_name: "Atoot Bhikari", tehsil_id: "1",Village_budget:"1002", },
        { village_id: "4", village_name: "lalwada", tehsil_id: "1", Village_budget:"1002", },
        { village_id: "5", village_name: "Badgaon Gujar", tehsil_id: "1",Village_budget:"1002", },
        { village_id: "6", village_name: "Sunderbel", tehsil_id: "1",Village_budget:"1002", },
        { village_id: "7", village_name: "Badgaon Mali", tehsil_id: "1" ,Village_budget:"1002",},
        { village_id: "8", village_name: "Baidiyaut Bhamgarh", tehsil_id: "1",Village_budget:"1002", },
        { village_id: "9", village_name: "Fatehpur Khandwa", tehsil_id: "1",Village_budget:"1002", },
        { village_id: "10", village_name: "Bhil Khedi Murar", tehsil_id: "1",Village_budget:"1002", },
        { village_id: "11", village_name: "Ladanpur", tehsil_id: "1",Village_budget:"1002", },
        { village_id: "12", village_name: "Bhaisawan", tehsil_id: "1",Village_budget:"1002", },
        { village_id: "13", village_name: "Bhakarda", tehsil_id: "1",Village_budget:"1002", },
        { village_id: "14", village_name: "Bhamgarh Nazul", tehsil_id: "1" ,Village_budget:"1002",},
        { village_id: "15", village_name: "Kanwani", tehsil_id: "1",Village_budget:"1002", },
        { village_id: "16", village_name: "Manpura", tehsil_id: "1" ,Village_budget:"1002",},
        { village_id: "17", village_name: "Amlani", tehsil_id: "1",Village_budget:"1002", },
        { village_id: "18", village_name: "Bhawsinghpura", tehsil_id: "1" ,Village_budget:"1002",},
        { village_id: "19", village_name: "Bijora Bhil", tehsil_id: "1" ,Village_budget:"1002",},
        { village_id: "20", village_name: "Borgaon Khurd", tehsil_id: "1",Village_budget:"1002", },
        
        
      ],
    },
    {
      tehsil_id: "2",
      tehsil_name: "Pandhana",
      District_id: "3",
      
      villages: [
        { village_id: "1", village_name: "Ambapat", tehsil_id: "2", Village_budget:"1002", },
        { village_id: "2", village_name: "Pipliya Kalan", tehsil_id: "2", Village_budget:"1002", },
        { village_id: "3", village_name: "Anjangaon", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "4", village_name: "Heerapur Khurd", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "5", village_name: "Arud", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "6", village_name: "Babli", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "7", village_name: "Badgaon Piplod", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "8", village_name: "Kedarkhedi", tehsil_id: "2", Village_budget:"1002", },
        { village_id: "9", village_name: "Baghmala", tehsil_id: "2", Village_budget:"1002", },
        { village_id: "10", village_name: "Bagmar", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "11", village_name: "Balkhad Ghati", tehsil_id: "2", Village_budget:"1002", },
        { village_id: "12", village_name: "Bandarla", tehsil_id: "2", Village_budget:"1002", },
        { village_id: "13", village_name: "Balrampur", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "14", village_name: "Balwada", tehsil_id: "2", Village_budget:"1002", },
        { village_id: "15", village_name: "Bamanda Ryt", tehsil_id: "2", Village_budget:"1002", },
        { village_id: "16", village_name: "Barar", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "17", village_name: "Bhagaiyapur", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "18", village_name: "Bhagwanpura", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "19", village_name: "Bhelkhed", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "20", village_name: "Itwamal", tehsil_id: "2", Village_budget:"1002", },
      ],
    },
    {
      tehsil_id: "3",
      tehsil_name: "Punasa",
      District_id: "3",
      Village_budget:"1002",
      villages: [
        { village_id: "1", village_name: "Anjaiya Kalan", tehsil_id: "2", Village_budget:"1002", },
        { village_id: "2", village_name: "Bhadlikheda", tehsil_id: "2", Village_budget:"1002", },
        { village_id: "3", village_name: "Anjainiya Khurd", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "4", village_name: "Aroda Ryt", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "5", village_name: "Atoo Khas", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "6", village_name: "Biharipura Khurd", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "7", village_name: "Bharipura Kala", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "8", village_name: "Kalya Khedi", tehsil_id: "2", Village_budget:"1002", },
        { village_id: "9", village_name: "Badnagar ryt", tehsil_id: "2", Village_budget:"1002", },
        { village_id: "10", village_name: "Bijapur", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "11", village_name: "Bkhatgarh", tehsil_id: "2", Village_budget:"1002", },
        { village_id: "12", village_name: "Sailani", tehsil_id: "2", Village_budget:"1002", },
        { village_id: "13", village_name: "Amoda Theka", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "14", village_name: "Bangarda", tehsil_id: "2", Village_budget:"1002", },
        { village_id: "15", village_name: "Beed", tehsil_id: "2", Village_budget:"1002", },
        { village_id: "16", village_name: "jhiranya Ryt", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "17", village_name: "Bhagwanpura", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "18", village_name: "Karond", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "19", village_name: "Bhawarla", tehsil_id: "2" , Village_budget:"1002",},
        { village_id: "20", village_name: "Takali", tehsil_id: "2", Village_budget:"1002", },
      ],
    },
    {
      tehsil_id: "4",
      tehsil_name: "Harsud",
      District_id: "3",
      Village_budget:"1002",
      villages: [
        { village_id: "1", village_name: "Badkhalya Mal", tehsil_id: "4", Village_budget:"1002", },
        { village_id: "2", village_name: "Mahatpura", tehsil_id: "4", Village_budget:"1002", },
        { village_id: "3", village_name: "Navalpura", tehsil_id: "4" , Village_budget:"1002",},
        { village_id: "4", village_name: "Chich Ryt", tehsil_id: "4" , Village_budget:"1004",},
        { village_id: "5", village_name: "Bahedi Ryt", tehsil_id: "4" , Village_budget:"1004",},
        { village_id: "6", village_name: "Barud Mal", tehsil_id: "4" , Village_budget:"1004",},
        { village_id: "7", village_name: "Rampuri Raiyat", tehsil_id: "4" , Village_budget:"1004",},
        { village_id: "8", village_name: "Imlani", tehsil_id: "4", Village_budget:"1004", },
        { village_id: "9", village_name: "Bharadi Ryt", tehsil_id: "4", Village_budget:"1004", },
        { village_id: "10", village_name: "Belwadi Ryt", tehsil_id: "4" , Village_budget:"1004",},
        { village_id: "11", village_name: "Khair Kheda", tehsil_id: "4", Village_budget:"1004", },
        { village_id: "12", village_name: "Chikhali Mal ", tehsil_id: "4", Village_budget:"1004", },
        { village_id: "13", village_name: "Bhawarli Mal", tehsil_id: "4" , Village_budget:"1004",},
        { village_id: "14", village_name: "RawPaur", tehsil_id: "4", Village_budget:"1004", },
        { village_id: "15", village_name: "Sonpura", tehsil_id: "4", Village_budget:"1004", },
        { village_id: "16", village_name: "Bori Saray", tehsil_id: "4" , Village_budget:"1004",},
        { village_id: "17", village_name: "Saktapur Ryt", tehsil_id: "4" , Village_budget:"1004",},
        { village_id: "18", village_name: "Charkheda Ryt", tehsil_id: "4" , Village_budget:"1004",},
        { village_id: "19", village_name: "Charkheda(Police abadi)", tehsil_id: "4" , Village_budget:"1004",},
        { village_id: "20", village_name: "Dawaldi", tehsil_id: "4", Village_budget:"1004", },
      ],
    },
    {
      tehsil_id: "5",
      tehsil_name: "Khalwa",
      District_id: "3",
      Village_budget:"1002",
      villages: [
        { village_id: "1", village_name: "Sawalidhad", tehsil_id: "5", Village_budget:"1005", },
        { village_id: "2", village_name: "Adakheda", tehsil_id: "5", Village_budget:"1005", },
        { village_id: "3", village_name: "Ambada", tehsil_id: "5" , Village_budget:"1005",},
        { village_id: "4", village_name: "Ashapur", tehsil_id: "5" , Village_budget:"1005",},
        { village_id: "5", village_name: "Awaliya Khalwa(F.V.)", tehsil_id: "5" , Village_budget:"1005",},
        { village_id: "6", village_name: "Awalya", tehsil_id: "5" , Village_budget:"1005",},
        { village_id: "7", village_name: "bhagpura", tehsil_id: "5" , Village_budget:"1005",},
        { village_id: "8", village_name: "Chadida", tehsil_id: "5", Village_budget:"1005", },
        { village_id: "9", village_name: "Chattu Battu", tehsil_id: "5", Village_budget:"1005", },
        { village_id: "10", village_name: "Bagda", tehsil_id: "5" , Village_budget:"1005",},
        { village_id: "11", village_name: "Piplya Bhoju", tehsil_id: "5", Village_budget:"1005", },
        { village_id: "12", village_name: "Barakund", tehsil_id: "5", Village_budget:"1005", },
        { village_id: "13", village_name: "Bhagawa", tehsil_id: "5" , Village_budget:"1005",},
        { village_id: "14", village_name: "Bhadangaya", tehsil_id: "5", Village_budget:"1005", },
        { village_id: "15", village_name: "Chainpur Sarkar", tehsil_id: "5", Village_budget:"1005", },
        { village_id: "16", village_name: "Chakara", tehsil_id: "5" , Village_budget:"1005",},
        { village_id: "17", village_name: "Gulai", tehsil_id: "5" , Village_budget:"1005",},
        { village_id: "18", village_name: "Dabhiya", tehsil_id: "5" , Village_budget:"1005",},
        { village_id: "19", village_name: "DeWali Kalan", tehsil_id: "5" , Village_budget:"1005",},
        { village_id: "20", village_name: "Dewali Khurd", tehsil_id: "5", Village_budget:"1005", },
      ],
    },
    
  ],
      },
// Dhar
{"District_id":"4","District_name":"Dhar","state_id":"1" , "tehsil": [
  {"tehsil_id":"1","tehsil_name":"Badnawar","District_id":"4", "villages": [
      {"village_id":"1","village_name":"Ajanya Khedi", "village_budget":"12345","tehsil_id":"1"},
      {"village_id":"2","village_name":"Amodiya","village_budget":"12345","tehsil_id":"1"},
      {"village_id":"3","village_name":"Babarda","village_budget":"12345","tehsil_id":"1"},
      {"village_id":"4","village_name":"Badwai","village_budget":"12345","tehsil_id":"1"},
      {"village_id":"5","village_name":"Bakhatgarh","village_budget":"12345","tehsil_id":"1"},
      {"village_id":"6","village_name":"Bakhatpura","village_budget":"12345","tehsil_id":"1"},
      {"village_id":"7","village_name":"Baloda","village_budget":"12345","tehsil_id":"1"},
      {"village_id":"8","village_name":"Bamakhedi","village_budget":"12345","tehsil_id":"1"},
      {"village_id":"9","village_name":"Bamanda Khurd","village_budget":"12345","tehsil_id":"1"},
      {"village_id":"10","village_name":"Bamansuta","village_budget":"12345","tehsil_id":"1"},
      {"village_id":"11","village_name":"Bamanya Rundi","village_budget":"12345","tehsil_id":"1"},
      {"village_id":"12","village_name":"Barodiya","village_budget":"12345","tehsil_id":"1"},
      {"village_id":"13","village_name":"Batwadiya Kalan","village_budget":"12345","tehsil_id":"1"},
      {"village_id":"14","village_name":"Batwadiya Khurd","village_budget":"12345","tehsil_id":"1"},
      {"village_id":"15","village_name":"Bawdiya","village_budget":"12345","tehsil_id":"1"},
      {"village_id":"16","village_name":"Beganda","village_budget":"12345","tehsil_id":"1"},
      {"village_id":"17","village_name":"Bhat Bamanda","village_budget":"12345","tehsil_id":"1"},
      {"village_id":"18","village_name":"Bhat Khareli","village_budget":"12345","tehsil_id":"1"},
      {"village_id":"19","village_name":"Bhensola","village_budget":"12345","tehsil_id":"1"},
      {"village_id":"20","village_name":"Bheroopada","village_budget":"12345","tehsil_id":"1"}
  ]},
  {"tehsil_id":"2","tehsil_name":"Dahi","District_id":"4", "villages": [
      {"village_id":"1","village_name":"Amalal","village_budget":"12345","tehsil_id":"2"},
      {"village_id":"2","village_name":"Arada","village_budget":"12345","tehsil_id":"2"},
      {"village_id":"3","village_name":"Atarsuma","village_budget":"12345","tehsil_id":"2"},
      {"village_id":"4","village_name":"Babli Khurd","village_budget":"12345","tehsil_id":"2"},
      {"village_id":"5","village_name":"Badvanya","village_budget":"12345","tehsil_id":"2"},
      {"village_id":"6","village_name":"Balvani","village_budget":"12345","tehsil_id":"2"},
      {"village_id":"7","village_name":"Barda","village_budget":"12345","tehsil_id":"2"},
      {"village_id":"8","village_name":"Bhagawa","village_budget":"12345","tehsil_id":"2"},
      {"village_id":"9","village_name":"Bodgon","village_budget":"12345","tehsil_id":"2"},
      {"village_id":"10","village_name":"Chakaliya","village_budget":"12345","tehsil_id":"2"},
      {"village_id":"11","village_name":"Chhachkua","village_budget":"12345","tehsil_id":"2"},
      {"village_id":"12","village_name":"Dahi","village_budget":"12345","tehsil_id":"2"},
      {"village_id":"13","village_name":"Dahramrai","village_budget":"12345","tehsil_id":"2"},
      {"village_id":"14","village_name":"Devdha","village_budget":"12345","tehsil_id":"2"},
      {"village_id":"15","village_name":"Dhengcha","village_budget":"12345","tehsil_id":"2"},
      {"village_id":"16","village_name":"Digavi","village_budget":"12345","tehsil_id":"2"},
      {"village_id":"17","village_name":"Gaajgota","village_budget":"12345","tehsil_id":"2"},
      {"village_id":"18","village_name":"Gangpur","village_budget":"12345","tehsil_id":"2"},
      {"village_id":"19","village_name":"Ghana","village_budget":"12345","tehsil_id":"2"},
      {"village_id":"20","village_name":"Jaamda","village_budget":"12345","tehsil_id":"2"}
  ]},
  {"tehsil_id":"3","tehsil_name":"Dhar","District_id":"4", "villages": [
      {"village_id":"1","village_name":"Aabu Khedi","village_budget":"12345","tehsil_id":"3"},
      {"village_id":"2","village_name":"Aali","village_budget":"12345","tehsil_id":"3"},
      {"village_id":"3","village_name":"Aam Kho","village_budget":"12345","tehsil_id":"3"},
      {"village_id":"4","village_name":"Achana","village_budget":"12345","tehsil_id":"3"},
      {"village_id":"5","village_name":"Adabaydapura","village_budget":"12345","tehsil_id":"3"},
      {"village_id":"6","village_name":"Adbeli","village_budget":"12345","tehsil_id":"3"},
      {"village_id":"7","village_name":"Advi","village_budget":"12345","tehsil_id":"3"},
      {"village_id":"8","village_name":"Ahirkhedi","village_budget":"12345","tehsil_id":"3"},
      {"village_id":"9","village_name":"Ahu","village_budget":"12345","tehsil_id":"3"},
      {"village_id":"10","village_name":"Akaldunadhar", "village_budget":"12345","tehsil_id":"3"},
      {"village_id":"11","village_name":"Akoda", "village_budget":"12345","tehsil_id":"3"},
      {"village_id":"12","village_name":"Akoliya","village_budget":"12345","tehsil_id":"3"},
      {"village_id":"13","village_name":"Ambakundia","village_budget":"12345","tehsil_id":"3"},
      {"village_id":"14","village_name":"Ambapura","village_budget":"12345","tehsil_id":"3"},
      {"village_id":"15","village_name":"Ambapura","village_budget":"12345","tehsil_id":"3"},
      {"village_id":"16","village_name":"Amkheda","village_budget":"12345","tehsil_id":"3"},
      {"village_id":"17","village_name":"Amla","village_budget":"12345","tehsil_id":"3"},
      {"village_id":"18","village_name":"Amliyabheru","village_budget":"12345","tehsil_id":"3"},
      {"village_id":"19","village_name":"Anarad","village_budget":"12345","tehsil_id":"3"},
      {"village_id":"20","village_name":"Anjnai","village_budget":"12345","tehsil_id":"3"}
  ]},
  {"tehsil_id":"4","tehsil_name":"Dharampuri","District_id":"4", "villages": [
      {"village_id":"1","village_name":"Abdulpur","village_budget":"12345","tehsil_id":"4"},
      {"village_id":"2","village_name":"Ahmadpura","village_budget":"12345","tehsil_id":"4"},
      {"village_id":"3","village_name":"Anupura Bahadar","village_budget":"12345","tehsil_id":"4"},
      {"village_id":"4","village_name":"Bagdialias Sagdi","village_budget":"12345","tehsil_id":"4"},
      {"village_id":"5","village_name":"Bagdipura","village_budget":"12345","tehsil_id":"4"},
      {"village_id":"6","village_name":"Bagwanya","village_budget":"12345","tehsil_id":"4"},
      {"village_id":"7","village_name":"Balwada","village_budget":"12345","tehsil_id":"4"},
      {"village_id":"8","village_name":"Balwari","village_budget":"12345","tehsil_id":"4"},
      {"village_id":"9","village_name":"Basvi","village_budget":"12345","tehsil_id":"4"},
      {"village_id":"10","village_name":"Beganda","village_budget":"12345","tehsil_id":"4"},
      {"village_id":"11","village_name":"Bhainsakho Buzurg","village_budget":"12345","tehsil_id":"4"},
      {"village_id":"12","village_name":"Bhainsakho Khurd","village_budget":"12345","tehsil_id":"4"},
      {"village_id":"13","village_name":"Bhandakho","village_budget":"12345","tehsil_id":"4"},
      {"village_id":"14","village_name":"Bharudpura","village_budget":"12345","tehsil_id":"4"},
      {"village_id":"15","village_name":"Bhatpura","village_budget":"12345","tehsil_id":"4"},
      {"village_id":"16","village_name":"Bhawanya Buzurg","village_budget":"12345","tehsil_id":"4"},
      {"village_id":"17","village_name":"Bhawanya Khurd","village_budget":"12345","tehsil_id":"4"},
      {"village_id":"18","village_name":"Bhawgaon","village_budget":"12345","tehsil_id":"4"},
      {"village_id":"19","village_name":"Bhodal","village_budget":"12345","tehsil_id":"4"},
      {"village_id":"20","village_name":"Bikhron","village_budget":"12345","tehsil_id":"4"}
  ]},
  {"tehsil_id":"5","tehsil_name":"Gandhwani","District_id":"4", "villages": [
      {"village_id":"1","village_name":"Ajarkunda","village_budget":"12345","tehsil_id":"5"},
      {"village_id":"2","village_name":"Ambajhiri","village_budget":"12345","tehsil_id":"5"},
      {"village_id":"3","village_name":"Amkhata","village_budget":"12345","tehsil_id":"5"},
      {"village_id":"4","village_name":"Anjantad","village_budget":"12345","tehsil_id":"5"},
      {"village_id":"5","village_name":"Atarsuma","village_budget":"12345","tehsil_id":"5"},
      {"village_id":"6","village_name":"Avaldaman","village_budget":"12345","tehsil_id":"5"},
      {"village_id":"7","village_name":"Badipur","village_budget":"12345","tehsil_id":"5"},
      {"village_id":"8","village_name":"Badiya","village_budget":"12345","tehsil_id":"5"},
      {"village_id":"9","village_name":"Badkhodra","village_budget":"12345","tehsil_id":"5"},
      {"village_id":"10","village_name":"Bakhatala","village_budget":"12345","tehsil_id":"5"},
      {"village_id":"11","village_name":"Baledi","village_budget":"12345","tehsil_id":"5"},
      {"village_id":"12","village_name":"Balnera","village_budget":"12345","tehsil_id":"5"},
      {"village_id":"13","village_name":"Balwari","village_budget":"12345","tehsil_id":"5"},
      {"village_id":"14","village_name":"Balwari Kalan","village_budget":"12345","tehsil_id":"5"},
      {"village_id":"15","village_name":"Balwari Khurd","village_budget":"12345","tehsil_id":"5"},
      {"village_id":"16","village_name":"Barahmangaon","village_budget":"12345","tehsil_id":"5"},
      {"village_id":"17","village_name":"Bariya","village_budget":"12345","tehsil_id":"5"},
      {"village_id":"18","village_name":"Bawadi Khodra","village_budget":"12345","tehsil_id":"5"},
      {"village_id":"19","village_name":"Beed Bhopawar","village_budget":"12345","tehsil_id":"5"},
      {"village_id":"20","village_name":"Behadada","village_budget":"12345","tehsil_id":"5"}
  ]},
  {"tehsil_id":"6","tehsil_name":"Kukshi","District_id":"4", "villages": [
      {"village_id":"1","village_name":"Agar","village_budget":"12345","tehsil_id":"6"},
      {"village_id":"2","village_name":"Ajanya Malhar","village_budget":"12345","tehsil_id":"6"},
      {"village_id":"3","village_name":"Akhada","village_budget":"12345","tehsil_id":"6"},
      {"village_id":"4","village_name":"Ali","village_budget":"12345","tehsil_id":"6"},
      {"village_id":"5","village_name":"Alonda","village_budget":"12345","tehsil_id":"6"},
      {"village_id":"6","village_name":"Amaljhuma","village_budget":"12345","tehsil_id":"6"},
      {"village_id":"7","village_name":"Ambada","village_budget":"12345","tehsil_id":"6"},
      {"village_id":"8","village_name":"Ambasoti","village_budget":"12345","tehsil_id":"6"},
      {"village_id":"9","village_name":"Anjan Khedi","village_budget":"12345","tehsil_id":"6"},
      {"village_id":"10","village_name":"Aspur","village_budget":"12345","tehsil_id":"6"},
      {"village_id":"11","village_name":"Awali","village_budget":"12345","tehsil_id":"6"},
      {"village_id":"12","village_name":"Babulgaon","village_budget":"12345","tehsil_id":"6"},
      {"village_id":"13","village_name":"Babulsha","village_budget":"12345","tehsil_id":"6"},
      {"village_id":"14","village_name":"Badgaon","village_budget":"12345","tehsil_id":"6"},
      {"village_id":"15","village_name":"Badgaon","village_budget":"12345","tehsil_id":"6"},
      {"village_id":"16","village_name":"Badgyar","village_budget":"12345","tehsil_id":"6"},
      {"village_id":"17","village_name":"Badkachha","village_budget":"12345","tehsil_id":"6"},
      {"village_id":"18","village_name":"Bagdi","village_budget":"12345","tehsil_id":"6"},
      {"village_id":"19","village_name":"Bagoli","village_budget":"12345","tehsil_id":"6"},
      {"village_id":"20","village_name":"Bagpura","village_budget":"12345","tehsil_id":"6"}
  ]},
  {"tehsil_id":"7","tehsil_name":"Manawar","District_id":"4", "villages": [
      {"village_id":"1","village_name":"Adabayda","village_budget":"12345","tehsil_id":"7"},
      {"village_id":"2","village_name":"Aghoda","village_budget":"12345","tehsil_id":"7"},
      {"village_id":"3","village_name":"Aharwads","village_budget":"12345","tehsil_id":"7"},
      {"village_id":"4","village_name":"Ahmadpur","village_budget":"12345","tehsil_id":"7"},
      {"village_id":"5","village_name":"Anjanda","village_budget":"12345","tehsil_id":"7"},
      {"village_id":"6","village_name":"Anjandikot","village_budget":"12345","tehsil_id":"7"},
      {"village_id":"7","village_name":"Anjandiman","village_budget":"12345","tehsil_id":"7"},
      {"village_id":"8","village_name":"Akalwara","village_budget":"12345","tehsil_id":"7"},
      {"village_id":"9","village_name":"Amlatha","village_budget":"12345","tehsil_id":"7"},
      {"village_id":"10","village_name":"amsi","village_budget":"12345","tehsil_id":"7"},
      {"village_id":"11","village_name":"Andiyab","village_budget":"12345","tehsil_id":"7"},
      {"village_id":"12","village_name":"Anjaniya","village_budget":"12345","tehsil_id":"7"},
      {"village_id":"13","village_name":"Avral","village_budget":"12345","tehsil_id":"7"},
      {"village_id":"14","village_name":"Badgaon","village_budget":"12345","tehsil_id":"7"},
      {"village_id":"15","village_name":"Badgaon","village_budget":"12345","tehsil_id":"7"},
      {"village_id":"16","village_name":"Badiya","village_budget":"12345","tehsil_id":"7"},
      {"village_id":"17","village_name":"Bagadi","village_budget":"12345","tehsil_id":"7"},
      {"village_id":"18","village_name":"Bagaliya","village_budget":"12345","tehsil_id":"7"},
      {"village_id":"19","village_name":"Bagsul","village_budget":"12345","tehsil_id":"7"},
      {"village_id":"20","village_name":"Bajattakhurd","village_budget":"12345","tehsil_id":"7"}
  ]},
  {"tehsil_id":"8","tehsil_name":"Sadarpur","District_id":"4", "villages": [
      {"village_id":"1","village_name":"Ahmad","village_budget":"12345","tehsil_id":"8"},
      {"village_id":"2","village_name":"Akolya","village_budget":"12345","tehsil_id":"8"},
      {"village_id":"3","village_name":"Amaliya","village_budget":"12345","tehsil_id":"8"},
      {"village_id":"4","village_name":"Amba","village_budget":"12345","tehsil_id":"8"},
      {"village_id":"5","village_name":"Ambamal","village_budget":"12345","tehsil_id":"8"},
      {"village_id":"6","village_name":"Ambapada","village_budget":"12345","tehsil_id":"8"},
      {"village_id":"7","village_name":"Ambedi","village_budget":"12345","tehsil_id":"8"},
      {"village_id":"8","village_name":"Amjhar","village_budget":"12345","tehsil_id":"8"},
      {"village_id":"9","village_name":"Amjhera","village_budget":"12345","tehsil_id":"8"},
      {"village_id":"10","village_name":"Amodiya","village_budget":"12345","tehsil_id":"8"},
      {"village_id":"11","village_name":"Anandkhedi","village_budget":"12345","tehsil_id":"8"},
      {"village_id":"12","village_name":"Anjan Mal","village_budget":"12345","tehsil_id":"8"},
      {"village_id":"13","village_name":"Antedi","village_budget":"12345","tehsil_id":"8"},
      {"village_id":"14","village_name":"Badbeli","village_budget":"12345","tehsil_id":"8"},
      {"village_id":"15","village_name":"Badodiya","village_budget":"12345","tehsil_id":"8"},
      {"village_id":"16","village_name":"Bagpipliya","village_budget":"12345","tehsil_id":"8"},
      {"village_id":"17","village_name":"Baloda","village_budget":"12345","tehsil_id":"8"},
      {"village_id":"18","village_name":"Bamankhedi","village_budget":"12345","tehsil_id":"8"},
      {"village_id":"19","village_name":"Bandedi","village_budget":"12345","tehsil_id":"8"},
      {"village_id":"20","village_name":"Bani","village_budget":"12345","tehsil_id":"8"}
  ]}

]},

// Alirajpur
{"District_id":"5","District_name":"Alirajpur","satate_id":"1" , "tehsil": [
  {"tehsil_id":"1","tehsil_name":"Alirajpur","District_id":"5",Village_budget:"1002", "villages": [
      {"village_id":"1","village_name":"Aali","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"2","village_name":"Abadiya","tehsil_id":"1,","Village_budget":"1005",},
      {"village_id":"3","village_name":"Achpai","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"4","village_name":"Adwada","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"5","village_name":"Agalgota","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"6","village_name":"Agran","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"7","village_name":"Ajanbara","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"8","village_name":"Ajanda","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"9","village_name":"Akaldhara","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"10","village_name":"Akalwa","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"11","village_name":"Akola","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"12","village_name":"Amba","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"13","village_name":"Amba Bada","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"14","village_name":"Amba Chhota","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"15","village_name":"Ambadaberi","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"16","village_name":"Ambaja","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"17","village_name":"Ambar","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"18","village_name":"Ambari","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"19","village_name":"Ambi","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"20","village_name":"Ambua","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"21","village_name":"Amjhiri","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"22","village_name":"Amkhut","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"23","village_name":"Amla","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"24","village_name":"Andharjhiri","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"25","village_name":"Andharkanch","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"26","village_name":"Arthi","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"27","village_name":"Athawa","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"28","village_name":"Attha","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"29","village_name":"Bada Undwa","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"30","village_name":"Badda","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"31","village_name":"Baddala","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"32","village_name":"Baddali","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"33","village_name":"Badi Bankhad","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"34","village_name":"Badi Gendra","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"35","village_name":"Badi Sardi","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"36","village_name":"Badi Utawali","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"37","village_name":"Badiwegalgaon","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"38","village_name":"Bahdiya ki Choki","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"39","village_name":"Baheda","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"40","village_name":"Baij","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"41","village_name":"Baijada","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"42","village_name":"Bakhatgarh","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"43","village_name":"Bamanta","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"44","village_name":"Band","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"45","village_name":"Bankhad chhoti","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"46","village_name":"Bayadiya","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"47","village_name":"Baydiya","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"48","village_name":"Begdi","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"49","village_name":"Behadwa","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"50","village_name":"Bhajiyana","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"51","village_name":"Bhanarawat","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"52","village_name":"Bhanchidi","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"53","village_name":"Bhawri","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"54","village_name":"Bhimbayda","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"55","village_name":"Bhitada","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"56","village_name":"Bholwat","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"57","village_name":"Bhopaliya","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"58","village_name":"Bhoran","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"59","village_name":"Bhordiya","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"60","village_name":"Bhordu","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"61","village_name":"Bhuriya Kuwa","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"62","village_name":"Bhuriyaamba","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"63","village_name":"Bichholi","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"64","village_name":"Bijoriya","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"65","village_name":"Bilghata","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"66","village_name":"Biljhiri","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"67","village_name":"Bilwat","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"68","village_name":"Binat","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"69","village_name":"Bodgaon","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"70","village_name":"Bokadiya","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"71","village_name":"Borana","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"72","village_name":"Bordabra","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"73","village_name":"Borkuwa","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"74","village_name":"Borwala","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"75","village_name":"Burma","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"76","village_name":"Chachriyaumda","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"77","village_name":"Chameli","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"78","village_name":"Chandar Muli","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"79","village_name":"Chandpur","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"80","village_name":"Chanota","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"81","village_name":"Chapariya","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"82","village_name":"Chhakna Ki Mal","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"83","village_name":"Chhaktala","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"84","village_name":"Chhinki","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"85","village_name":"Chhota Undwa","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"86","village_name":"Chhoti Hatwi","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"87","village_name":"Chhoti Sardi","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"88","village_name":"Chhoti Utawali","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"89","village_name":"chhoti Wegalgaon","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"90","village_name":"Chichalguda","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"91","village_name":"Chichlana","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"92","village_name":"Chikhahali","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"93","village_name":"ChiKhalkui","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"94","village_name":"Chikhola","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"95","village_name":"Chilkada","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"96","village_name":"Chilwat","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"97","village_name":"Chimata","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"98","village_name":"Choganwat","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"99","village_name":"Chohji","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"100","village_name":"Chordha","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"101","village_name":"Dabdi","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"102","village_name":"Daberi","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"103","village_name":"Darja","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"104","village_name":"Darkali","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"105","village_name":"Darkhad","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"106","village_name":"Dehri","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"107","village_name":"Delwani","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"108","village_name":"Det Kunda","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"109","village_name":"Dhakkapura","tehsil_id":"1","Village_budget":"1005",},
      {"village_id":"110","village_name":"Dhanpur","tehsil_id":"1"},
      {"village_id":"111","village_name":"Dhayana","tehsil_id":"1"},
      {"village_id":"112","village_name":"Dhalkheda","tehsil_id":"1"},
      {"village_id":"113","village_name":"Dhorat","tehsil_id":"1"},
      {"village_id":"114","village_name":"Dindwat","tehsil_id":"1"},
      {"village_id":"115","village_name":"Dipa ki Choki","tehsil_id":"1"},
      {"village_id":"116","village_name":"Doblajhiri","tehsil_id":"1"},
      {"village_id":"117","village_name":"Dokarbariya","tehsil_id":"1"},
      {"village_id":"118","village_name":"Dupkhadda","tehsil_id":"1"},
      {"village_id":"119","village_name":"Dudalwat","tehsil_id":"1"},
      {"village_id":"120","village_name":"Dudhwi","tehsil_id":"1"},
      {"village_id":"121","village_name":"Dungargaon","tehsil_id":"1"},
      {"village_id":"122","village_name":"Dungriya","tehsil_id":"1"},
      {"village_id":"123","village_name":"Ekdhadi","tehsil_id":"1"},
      {"village_id":"124","village_name":"Esdu","tehsil_id":"1"},
      {"village_id":"125","village_name":"Fadtala Badi","tehsil_id":"1"},
      {"village_id":"126","village_name":"Fadtala Chhoti","tehsil_id":"1"},
      {"village_id":"127","village_name":"Faliyamau","tehsil_id":"1"},
      {"village_id":"128","village_name":"Fartala","tehsil_id":"1"},
      {"village_id":"129","village_name":"Fata","tehsil_id":"1"},
      {"village_id":"130","village_name":"Fulmal","tehsil_id":"1"},
      {"village_id":"131","village_name":"gadat","tehsil_id":"1"},
      {"village_id":"132","village_name":"Gahwan","tehsil_id":"1"},
      {"village_id":"133","village_name":"Gata","tehsil_id":"1"},
      {"village_id":"134","village_name":"Genda","tehsil_id":"1"},
      {"village_id":"135","village_name":"Gendra Chhoti","tehsil_id":"1"},
      {"village_id":"136","village_name":"Ghatwani","tehsil_id":"1"},
      {"village_id":"137","village_name":"Ghodiyadara","tehsil_id":"1"},
      {"village_id":"138","village_name":"Ghoghalpur","tehsil_id":"1"},
      {"village_id":"139","village_name":"Ghunghasa","tehsil_id":"1"},
      {"village_id":"140","village_name":"Ghunt","tehsil_id":"1"},
      {"village_id":"141","village_name":"Giljhiri","tehsil_id":"1"},
      {"village_id":"142","village_name":"Girala","tehsil_id":"1"},
      {"village_id":"143","village_name":"Gol Amba","tehsil_id":"1"},
      {"village_id":"144","village_name":"Golapalwi","tehsil_id":"1"},
      {"village_id":"145","village_name":"Gondwani","tehsil_id":"1"},
      {"village_id":"146","village_name":"Guda","tehsil_id":"1"},
      {"village_id":"147","village_name":"Gulwate","tehsil_id":"1"},
      {"village_id":"148","village_name":"Guneri","tehsil_id":"1"},
      {"village_id":"149","village_name":"Haraswat","tehsil_id":"1"},
      {"village_id":"150","village_name":"Harod","tehsil_id":"1"},
      {"village_id":"151","village_name":"Hatvi Badi","tehsil_id":"1"},
      {"village_id":"152","village_name":"Havelikheda","tehsil_id":"1"},
      {"village_id":"153","village_name":"Indalwat","tehsil_id":"1"},
      {"village_id":"154","village_name":"Indarsing Ki Choki","tehsil_id":"1"},
      {"village_id":"155","village_name":"Indi","tehsil_id":"1"},
      {"village_id":"156","village_name":"Jabbaniya","tehsil_id":"1"},
      {"village_id":"157","village_name":"Jalsindhi","tehsil_id":"1"},
      {"village_id":"158","village_name":"Jamaniya","tehsil_id":"1"},
      {"village_id":"159","village_name":"Jamta","tehsil_id":"1"},
      {"village_id":"160","village_name":"Jamli","tehsil_id":"1"},
      {"village_id":"161","village_name":"Jetpur","tehsil_id":"1"},
      {"village_id":"162","village_name":"Jhadoli","tehsil_id":"1"},
      {"village_id":"163","village_name":"Jhandana","tehsil_id":"1"},
      {"village_id":"164","village_name":"Jharkali","tehsil_id":"1"},
      {"village_id":"165","village_name":"Jhinjhana","tehsil_id":"1"},
      {"village_id":"166","village_name":"Jholiya","tehsil_id":"1"},
      {"village_id":"167","village_name":"Jhora","tehsil_id":"1"},
      {"village_id":"168","village_name":"Juna Kattiwada","tehsil_id":"1"},
      {"village_id":"169","village_name":"Kaati","tehsil_id":"1"},
      {"village_id":"170","village_name":"Kabricell","tehsil_id":"1"},
      {"village_id":"171","village_name":"Kadwal","tehsil_id":"1"},
      {"village_id":"172","village_name":"kadwaliya","tehsil_id":"1"},
      {"village_id":"173","village_name":"Kadwaniya","tehsil_id":"1"},
      {"village_id":"174","village_name":"Kail","tehsil_id":"1"},
      {"village_id":"175","village_name":"Kakadsela","tehsil_id":"1"},
      {"village_id":"176","village_name":"Kakadwal","tehsil_id":"1"},
      {"village_id":"177","village_name":"Kakrana","tehsil_id":"1"},
      {"village_id":"178","village_name":"Kalibel","tehsil_id":"1"},
      {"village_id":"179","village_name":"Kalmaja","tehsil_id":"1"},
      {"village_id":"180","village_name":"Kanchhla","tehsil_id":"1"},
      {"village_id":"181","village_name":"Kanera","tehsil_id":"1"},
      {"village_id":"182","village_name":"Kanpur","tehsil_id":"1"},
      {"village_id":"183","village_name":"Kanphari","tehsil_id":"1"},
      {"village_id":"184","village_name":"Karah","tehsil_id":"1"},
      {"village_id":"185","village_name":"Karajwana","tehsil_id":"1"},
      {"village_id":"186","village_name":"Kardha","tehsil_id":"1"},
      {"village_id":"187","village_name":"Karelimahudi","tehsil_id":"1"},
      {"village_id":"188","village_name":"Kasariya","tehsil_id":"1"},
      {"village_id":"189","village_name":"Kasatbani","tehsil_id":"1"},
      {"village_id":"190","village_name":"Katnwad","tehsil_id":"1"},
      {"village_id":"191","village_name":"Kattiwada Khas","tehsil_id":"1"},
      {"village_id":"192","village_name":"Kavchha","tehsil_id":"1"},
      {"village_id":"193","village_name":"Kawthu","tehsil_id":"1"},
      {"village_id":"194","village_name":"Keldi Ki Mal","tehsil_id":"1"},
      {"village_id":"195","village_name":"Kerali","tehsil_id":"1"},
      {"village_id":"196","village_name":"Kewda","tehsil_id":"1"},
      {"village_id":"197","village_name":"Kewdi","tehsil_id":"1"},
      {"village_id":"198","village_name":"Khamat","tehsil_id":"1"},
      {"village_id":"199","village_name":"Khamba","tehsil_id":"1"},
      {"village_id":"200","village_name":"Khamdaka","tehsil_id":"1"},
      {"village_id":"201","village_name":"Khandala","tehsil_id":"1"},
      {"village_id":"202","village_name":"Khar Kuwa","tehsil_id":"1"},
      {"village_id":"203","village_name":"Kharkali","tehsil_id":"1"},
      {"village_id":"204","village_name":"Kharkhri","tehsil_id":"1"},
      {"village_id":"205","village_name":"Kharpai","tehsil_id":"1"},
      {"village_id":"206","village_name":"Khattal","tehsil_id":"1"},
      {"village_id":"207","village_name":"Kheda","tehsil_id":"1"},
      {"village_id":"208","village_name":"Kheda Bada","tehsil_id":"1"},
      {"village_id":"209","village_name":"Kherwa","tehsil_id":"1"},
      {"village_id":"210","village_name":"Kherwad","tehsil_id":"1"},
      {"village_id":"211","village_name":"Kherwada","tehsil_id":"1"},
      {"village_id":"212","village_name":"Khod Amba","tehsil_id":"1"},
      {"village_id":"213","village_name":"Khod Jamli","tehsil_id":"1"},
      {"village_id":"214","village_name":"Khun Dar","tehsil_id":"1"},
      {"village_id":"215","village_name":"Khundi","tehsil_id":"1"},
      {"village_id":"216","village_name":"Kiloda","tehsil_id":"1"},
      {"village_id":"217","village_name":"Kiti","tehsil_id":"1"},
      {"village_id":"218","village_name":"Kodla","tehsil_id":"1"},
      {"village_id":"219","village_name":"Kodli","tehsil_id":"1"},
      {"village_id":"220","village_name":"Koha","tehsil_id":"1"},
      {"village_id":"221","village_name":"Kohibav","tehsil_id":"1"},
      {"village_id":"222","village_name":"Kolyari","tehsil_id":"1"},
      {"village_id":"223","village_name":"Kotbu","tehsil_id":"1"},
      {"village_id":"224","village_name":"Kotharmahua","tehsil_id":"1"},
      {"village_id":"225","village_name":"Kukadiya","tehsil_id":"1"},
      {"village_id":"226","village_name":"Kukawat","tehsil_id":"1"},
      {"village_id":"227","village_name":"Kuklat","tehsil_id":"1"},
      {"village_id":"228","village_name":"Kulwat","tehsil_id":"1"},
      {"village_id":"229","village_name":"Kumbhi","tehsil_id":"1"},
      {"village_id":"230","village_name":"Kund","tehsil_id":"1"},
      {"village_id":"231","village_name":"Kundola","tehsil_id":"1"},
      {"village_id":"232","village_name":"Kunwat","tehsil_id":"1"},
      {"village_id":"233","village_name":"Kushalwai","tehsil_id":"1"},
      {"village_id":"234","village_name":"Kusumba","tehsil_id":"1"},
      {"village_id":"235","village_name":"Lakhan Kot","tehsil_id":"1"},
      {"village_id":"236","village_name":"Lakhawat","tehsil_id":"1"},
      {"village_id":"237","village_name":"Laxmani","tehsil_id":"1"},
      {"village_id":"238","village_name":"Limdiwat","tehsil_id":"1"},
      {"village_id":"239","village_name":"Lodhni","tehsil_id":"1"},
      {"village_id":"240","village_name":"Machhaliya","tehsil_id":"1"},
      {"village_id":"241","village_name":"Madhupalwi","tehsil_id":"1"},
      {"village_id":"242","village_name":"Mahalgaon","tehsil_id":"1"},
      {"village_id":"243","village_name":"Malwai","tehsil_id":"1"},
      {"village_id":"244","village_name":"Mandhar","tehsil_id":"1"},
      {"village_id":"245","village_name":"Mankhada","tehsil_id":"1"},
      {"village_id":"246","village_name":"Masni","tehsil_id":"1"},
      {"village_id":"247","village_name":"Mathwad","tehsil_id":"1"},
      {"village_id":"248","village_name":"Mayala","tehsil_id":"1"},
      {"village_id":"249","village_name":"Mehji","tehsil_id":"1"},
      {"village_id":"250","village_name":"Mohi","tehsil_id":"1"},
      {"village_id":"251","village_name":"Moraji","tehsil_id":"1"},
      {"village_id":"252","village_name":"Morasa","tehsil_id":"1"},
      {"village_id":"253","village_name":"Mordha","tehsil_id":"1"},
      {"village_id":"254","village_name":"Mordhi","tehsil_id":"1"},
      {"village_id":"255","village_name":"Moriya Ka Bada","tehsil_id":"1"},
      {"village_id":"256","village_name":"Moriyagaon","tehsil_id":"1"},
      {"village_id":"257","village_name":"Moti Badoi","tehsil_id":"1"},
      {"village_id":"258","village_name":"Motibar","tehsil_id":"1"},
      {"village_id":"259","village_name":"Muljipura","tehsil_id":"1"},
      {"village_id":"260","village_name":"Mundla","tehsil_id":"1"},
      {"village_id":"261","village_name":"Nakti","tehsil_id":"1"},
      {"village_id":"262","village_name":"Nani Badoi","tehsil_id":"1"},
      {"village_id":"263","village_name":"Nanibar","tehsil_id":"1"},
      {"village_id":"264","village_name":"Nanpur","tehsil_id":"1"},
      {"village_id":"265","village_name":"NichaWas","tehsil_id":"1"},
      {"village_id":"266","village_name":"OJhad","tehsil_id":"1"},
      {"village_id":"267","village_name":"Padola","tehsil_id":"1"},
      {"village_id":"268","village_name":"Palasda","tehsil_id":"1"},
      {"village_id":"269","village_name":"Panala","tehsil_id":"1"},
      {"village_id":"270","village_name":"Panguda","tehsil_id":"1"},
      {"village_id":"271","village_name":"Panmaudi","tehsil_id":"1"},
      {"village_id":"272","village_name":"Panwani","tehsil_id":"1"},
      {"village_id":"273","village_name":"Parta","tehsil_id":"1"},
      {"village_id":"274","village_name":"Pipal kanch","tehsil_id":"1"},
      {"village_id":"275","village_name":"Pipariya","tehsil_id":"1"},
      {"village_id":"276","village_name":"Piplyawat","tehsil_id":"1"},
      {"village_id":"277","village_name":"Pithanpur","tehsil_id":"1"},
      {"village_id":"278","village_name":"Pratappura","tehsil_id":"1"},
      {"village_id":"279","village_name":"Pujari Ki Choki","tehsil_id":"1"},
      {"village_id":"280","village_name":"Punyawat","tehsil_id":"1"},
      {"village_id":"281","village_name":"puwasa","tehsil_id":"1"},
      {"village_id":"282","village_name":"Raddhu","tehsil_id":"1"},
      {"village_id":"283","village_name":"Rajawat","tehsil_id":"1"},
      {"village_id":"284","village_name":"Raksala","tehsil_id":"1"},
      {"village_id":"285","village_name":"Ramsingh Ki choki","tehsil_id":"1"},
      {"village_id":"286","village_name":"Raodi","tehsil_id":"1"},
      {"village_id":"287","village_name":"Ratad","tehsil_id":"1"},
      {"village_id":"288","village_name":"Rathodi","tehsil_id":"1"},
      {"village_id":"289","village_name":"Raychha","tehsil_id":"1"},
      {"village_id":"290","village_name":"Rachhvi","tehsil_id":"1"},
      {"village_id":"291","village_name":"Roddha","tehsil_id":"1"},
      {"village_id":"292","village_name":"Roligaon","tehsil_id":"1"},
      {"village_id":"293","village_name":"Roshiya","tehsil_id":"1"},
      {"village_id":"294","village_name":"Rund Mal","tehsil_id":"1"},
      {"village_id":"295","village_name":"Sadli","tehsil_id":"1"},
      {"village_id":"296","village_name":"Sagbara","tehsil_id":"1"},
      {"village_id":"297","village_name":"Saija","tehsil_id":"1"},
      {"village_id":"298","village_name":"Sajanpur","tehsil_id":"1"},
      {"village_id":"299","village_name":"Sakarja","tehsil_id":"1"},
      {"village_id":"300","village_name":"Sakdi","tehsil_id":"1"},
      {"village_id":"301","village_name":"Samra","tehsil_id":"1"},
      {"village_id":"302","village_name":"Satpal","tehsil_id":"1"},
      {"village_id":"303","village_name":"Sayda","tehsil_id":"1"},
      {"village_id":"304","village_name":"Sejgaon","tehsil_id":"1"},
      {"village_id":"305","village_name":"Semlani","tehsil_id":"1"},
      {"village_id":"306","village_name":"Silota","tehsil_id":"1"},
      {"village_id":"307","village_name":"Sirkhadi Badi","tehsil_id":"1"},
      {"village_id":"308","village_name":"Sirkhadi Chhoti","tehsil_id":"1"},
      {"village_id":"309","village_name":"Siswaliya","tehsil_id":"1"},
      {"village_id":"310","village_name":"Soliya","tehsil_id":"1"},
      {"village_id":"311","village_name":"Someshpura","tehsil_id":"1"},
      {"village_id":"312","village_name":"Somkuwa","tehsil_id":"1"},
      {"village_id":"313","village_name":"Sondwa","tehsil_id":"1"},
      {"village_id":"314","village_name":"Sorwa","tehsil_id":"1"},
      {"village_id":"315","village_name":"Sugat","tehsil_id":"1"},
      {"village_id":"316","village_name":"Sukhi Bawadi","tehsil_id":"1"},
      {"village_id":"317","village_name":"Sumaniyawat","tehsil_id":"1"},
      {"village_id":"318","village_name":"Temla","tehsil_id":"1"},
      {"village_id":"319","village_name":"Thanasemli","tehsil_id":"1"},
      {"village_id":"320","village_name":"Tharwata","tehsil_id":"1"},
      {"village_id":"321","village_name":"Thod Sindhi","tehsil_id":"1"},
      {"village_id":"322","village_name":"Tikhola","tehsil_id":"1"},
      {"village_id":"323","village_name":"Titi","tehsil_id":"1"},
      {"village_id":"324","village_name":"Umarkhad","tehsil_id":"1"},
      {"village_id":"325","village_name":"Umarwada","tehsil_id":"1"},
      {"village_id":"326","village_name":"Umrali","tehsil_id":"1"},
      {"village_id":"327","village_name":"Umrath","tehsil_id":"1"},
      {"village_id":"328","village_name":"Umri","tehsil_id":"1"},
      {"village_id":"329","village_name":"Unala","tehsil_id":"1"},
      {"village_id":"330","village_name":"Undari","tehsil_id":"1"},
      {"village_id":"331","village_name":"Wadi","tehsil_id":"1"},
      {"village_id":"332","village_name":"Wakner","tehsil_id":"1"},
      {"village_id":"333","village_name":"Wakneri","tehsil_id":"1"},
      {"village_id":"334","village_name":"Walpur","tehsil_id":"1"},
      {"village_id":"335","village_name":"Walwai","tehsil_id":"1"},
      {"village_id":"336","village_name":"Waskal","tehsil_id":"1"},
      {"village_id":"337","village_name":"Wav","tehsil_id":"1"},
      {"village_id":"338","village_name":"Wawi","tehsil_id":"1"},
      {"village_id":"339","village_name":"Weswani","tehsil_id":"1"},

  ]},
  {"tehsil_id":"2","tehsil_name":"Bhavra","District_id":"5", "villages": [
     {"village_id":"1","village_name":"Airan","tehsil_id":"2","Village_budget":"1005",},
      {"village_id":"2","village_name":"Aman kuwa","tehsil_id":"2","Village_budget":"1005",},
      {"village_id":"3","village_name":"Badgaon","tehsil_id":"2","Village_budget":"1005",},
      {"village_id":"4","village_name":"Bahedawa","tehsil_id":"2","Village_budget":"1005",},
      {"village_id":"5","village_name":"Barjhar","tehsil_id":"2","Village_budget":"1005",},
      {"village_id":"6","village_name":"Barkheda","tehsil_id":"2","Village_budget":"1005",},
      {"village_id":"7","village_name":"Bhawata Bada","tehsil_id":"2","Village_budget":"1005",},
      {"village_id":"8","village_name":"Bhawata Chhota","tehsil_id":"2","Village_budget":"1005",},
      {"village_id":"9","village_name":"Bhuriya Kuwa","tehsil_id":"2","Village_budget":"1005",},
      {"village_id":"10","village_name":"Bina","tehsil_id":"2","Village_budget":"1005",},
      {"village_id":"11","village_name":"Borka Aara","tehsil_id":"2","Village_budget":"1005",},
      {"village_id":"12","village_name":"Borkundiya","tehsil_id":"2","Village_budget":"1005",},
      {"village_id":"13","village_name":"Chapri","tehsil_id":"2","Village_budget":"1005",},
      {"village_id":"14","village_name":"Deetya ka Falya","tehsil_id":"2","Village_budget":"1005",},
      {"village_id":"15","village_name":"Dewali","tehsil_id":"2","Village_budget":"1005",},
      {"village_id":"16","village_name":"Dungaliwani","tehsil_id":"2","Village_budget":"1005",},
      {"village_id":"17","village_name":"Fata Badi","tehsil_id":"2","Village_budget":"1005",},
      {"village_id":"18","village_name":"Fata Chhoti","tehsil_id":"2","Village_budget":"1005",},
      {"village_id":"19","village_name":"GeruGhati","tehsil_id":"2","Village_budget":"1005",},
      {"village_id":"20","village_name":"Girdha","tehsil_id":"2","Village_budget":"1005",},
      {"village_id":"21","village_name":"Jawaniya","tehsil_id":"2"},
      {"village_id":"22","village_name":"Jhiran","tehsil_id":"2"},
      {"village_id":"23","village_name":"Kakadbari","tehsil_id":"2"},
      {"village_id":"24","village_name":"Kaliyawav","tehsil_id":"2"},
      {"village_id":"25","village_name":"Kansath","tehsil_id":"2"},
      {"village_id":"26","village_name":"Kareti Badi","tehsil_id":"2"},
      {"village_id":"27","village_name":"Kareti Chhoti","tehsil_id":"2"},
      {"village_id":"28","village_name":"Keheriya Mali","tehsil_id":"2"},
      {"village_id":"29","village_name":"Khutaja Bada","tehsil_id":"2"},
      {"village_id":"30","village_name":"Khutaja Chhota","tehsil_id":"2"},
      {"village_id":"31","village_name":"Kilana","tehsil_id":"2"},
      {"village_id":"32","village_name":"Koriya pan","tehsil_id":"2"},
      {"village_id":"33","village_name":"Kuhiwav","tehsil_id":"2"},
      {"village_id":"34","village_name":"Lilumari","tehsil_id":"2"},
      {"village_id":"35","village_name":"Mahendra","tehsil_id":"2"},
      {"village_id":"36","village_name":"Malpur Badi","tehsil_id":"2"},
      {"village_id":"37","village_name":"Malpur Chhoti","tehsil_id":"2"},
      {"village_id":"38","village_name":"Malweli","tehsil_id":"2"},
      {"village_id":"39","village_name":"Mathana","tehsil_id":"2"},
      {"village_id":"40","village_name":"Mayawat","tehsil_id":"2"},
      {"village_id":"41","village_name":"Mendha","tehsil_id":"2"},
      {"village_id":"42","village_name":"Miriyawat Chhoti","tehsil_id":"2"},
      {"village_id":"43","village_name":"Miriyawat Badi","tehsil_id":"2"},
      {"village_id":"44","village_name":"Polbadi","tehsil_id":"2"},
      {"village_id":"45","village_name":"Polchhoti","tehsil_id":"2"},
      {"village_id":"46","village_name":"Ringol","tehsil_id":"2"},
      {"village_id":"47","village_name":"Roligaon","tehsil_id":"2"},
      {"village_id":"48","village_name":"Sanda","tehsil_id":"2"},
      {"village_id":"49","village_name":"Sejawada","tehsil_id":"2"},
      {"village_id":"50","village_name":"Tati Amba","tehsil_id":"2"},
  ]},
   {"tehsil_id":"3","tehsil_name":"Jobat","District_id":"5", "villages": [
       {"village_id":"1","village_name":"Agoni","tehsil_id":"3","Village_budget":"1005",},
      {"village_id":"2","village_name":"Akgoli","tehsil_id":"3","Village_budget":"1005",},
      {"village_id":"3","village_name":"Ambakhedi","tehsil_id":"3","Village_budget":"1005",},
      {"village_id":"4","village_name":"Ambi","tehsil_id":"3","Village_budget":"1005",},
      {"village_id":"5","village_name":"Arandi Falya","tehsil_id":"3","Village_budget":"1005",},
      {"village_id":"6","village_name":"Badha Itara","tehsil_id":"3","Village_budget":"1005",},
      {"village_id":"7","village_name":"Badhaguda","tehsil_id":"3","Village_budget":"1005",},
      {"village_id":"8","village_name":"Badi Juwari","tehsil_id":"3","Village_budget":"1005",},
      {"village_id":"9","village_name":"Badi Khattali","tehsil_id":"3","Village_budget":"1005",},
      {"village_id":"10","village_name":"Bahediya","tehsil_id":"3","Village_budget":"1005",},
      {"village_id":"11","village_name":"Bakal Badi","tehsil_id":"3","Village_budget":"1005",},
      {"village_id":"12","village_name":"Bakal Chhoti","tehsil_id":"3","Village_budget":"1005",},
      {"village_id":"13","village_name":"Baladmoong","tehsil_id":"3","Village_budget":"1005",},
      {"village_id":"14","village_name":"Baledi","tehsil_id":"3","Village_budget":"1005",},
      {"village_id":"15","village_name":"Baodi","tehsil_id":"3","Village_budget":"1005",},
      {"village_id":"16","village_name":"Barda","tehsil_id":"3","Village_budget":"1005",},
      {"village_id":"17","village_name":"Barkheda","tehsil_id":"3","Village_budget":"1005",},
      {"village_id":"18","village_name":"Bavdi Khurd","tehsil_id":"3","Village_budget":"1005",},
      {"village_id":"19","village_name":"Bawadi Falya","tehsil_id":"3","Village_budget":"1005",},
      {"village_id":"20","village_name":"Begda","tehsil_id":"3","Village_budget":"1005",},
      {"village_id":"21","village_name":"Betwasa","tehsil_id":"3"},
      {"village_id":"22","village_name":"Bhaisawada","tehsil_id":"3"},
      {"village_id":"23","village_name":"Bhandakhapar","tehsil_id":"3"},
      {"village_id":"24","village_name":"Bhanpur","tehsil_id":"3"},
      {"village_id":"25","village_name":"Bhilkhedi","tehsil_id":"3"},
      {"village_id":"26","village_name":"Bhiti","tehsil_id":"3"},
      {"village_id":"27","village_name":"Bhorkuwa","tehsil_id":"3"},
      {"village_id":"28","village_name":"Bhurchhewadi","tehsil_id":"3"},
      {"village_id":"29","village_name":"Bid badi","tehsil_id":"3"},
      {"village_id":"30","village_name":"Bid chhoti","tehsil_id":"3"},
      {"village_id":"31","village_name":"Bilasa","tehsil_id":"3"},
      {"village_id":"32","village_name":"Bori","tehsil_id":"3"},
      {"village_id":"33","village_name":"Borjhad","tehsil_id":"3"},
      {"village_id":"34","village_name":"Budkui Badi","tehsil_id":"3"},
      {"village_id":"35","village_name":"Budkui Chhoti","tehsil_id":"3"},
      {"village_id":"36","village_name":"Chagdi","tehsil_id":"3"},
      {"village_id":"37","village_name":"Chamar Begda","tehsil_id":"3"},
      {"village_id":"38","village_name":"Chharwi","tehsil_id":"3"},
      {"village_id":"39","village_name":"Chhota itara","tehsil_id":"3"},
      {"village_id":"40","village_name":"Chhotaguda","tehsil_id":"3"},
      {"village_id":"41","village_name":"Chhoti Jhiri","tehsil_id":"3"},
      {"village_id":"42","village_name":"Chhoti Juwari","tehsil_id":"3"},
      {"village_id":"43","village_name":"Chohli","tehsil_id":"3"},
      {"village_id":"44","village_name":"Chotya Bayadee","tehsil_id":"3"},
      {"village_id":"45","village_name":"Chuliya","tehsil_id":"3"},
      {"village_id":"46","village_name":"Dabadi","tehsil_id":"3"},
      {"village_id":"47","village_name":"Dadarwasa","tehsil_id":"3"},
      {"village_id":"48","village_name":"Degaon","tehsil_id":"3"},
      {"village_id":"49","village_name":"Dehdala","tehsil_id":"3"},
      {"village_id":"50","village_name":"Dekakund","tehsil_id":"3"},
      {"village_id":"51","village_name":"Dekalkuwa","tehsil_id":"3"},
      {"village_id":"52","village_name":"Dewlai","tehsil_id":"3"},
      {"village_id":"53","village_name":"Dhamanda","tehsil_id":"3"},
      {"village_id":"54","village_name":"Futtalab Bada","tehsil_id":"3"},
      {"village_id":"55","village_name":"Futtalab Chhota","tehsil_id":"3"},
      {"village_id":"56","village_name":"Gawani Salar","tehsil_id":"3"},
      {"village_id":"57","village_name":"Ghoghasiya","tehsil_id":"3"},
      {"village_id":"58","village_name":"Ghunjheri","tehsil_id":"3"},
      {"village_id":"59","village_name":"Handi","tehsil_id":"3"},
      {"village_id":"60","village_name":"Hardarpur","tehsil_id":"3"},
      {"village_id":"61","village_name":"Hirapur Badi","tehsil_id":"3"},
      {"village_id":"62","village_name":"Hirapur Chhoti","tehsil_id":"3"},
      {"village_id":"63","village_name":"Indwan","tehsil_id":"3"},
      {"village_id":"64","village_name":"Jaisingpur","tehsil_id":"3"},
      {"village_id":"65","village_name":"jali","tehsil_id":"3"},
      {"village_id":"66","village_name":"Jmbukheda","tehsil_id":"3"},
      {"village_id":"67","village_name":"Jameri","tehsil_id":"3"},
      {"village_id":"68","village_name":"Jamli Badi","tehsil_id":"3"},
      {"village_id":"69","village_name":"Jamli Chhoti","tehsil_id":"3"},
      {"village_id":"70","village_name":"Jamni","tehsil_id":"3"},
      {"village_id":"71","village_name":"Jawas","tehsil_id":"3"},
      {"village_id":"72","village_name":"Jhiri Badi","tehsil_id":"3"},
      {"village_id":"73","village_name":"Kadwal","tehsil_id":"3"},
      {"village_id":"74","village_name":"Kadwal Badi","tehsil_id":"3"},
      {"village_id":"75","village_name":"Kadwal Chhoti","tehsil_id":"3"},
      {"village_id":"76","village_name":"kali Khetar","tehsil_id":"3"},
      {"village_id":"77","village_name":"Kaluwat","tehsil_id":"3"},
      {"village_id":"78","village_name":"Kana Kakad","tehsil_id":"3"},
      {"village_id":"79","village_name":"Kanda","tehsil_id":"3"},
      {"village_id":"80","village_name":"Kanwada","tehsil_id":"3"},
      {"village_id":"81","village_name":"Kanwadudal","tehsil_id":"3"},
      {"village_id":"82","village_name":"Kasba Jobat","tehsil_id":"3"},
      {"village_id":"83","village_name":"Katkuwa","tehsil_id":"3"},
      {"village_id":"84","village_name":"Keljhara","tehsil_id":"3"},
      {"village_id":"85","village_name":"Keshariya Waree","tehsil_id":"3"},
      {"village_id":"86","village_name":"Khandala Gamir","tehsil_id":"3"},
      {"village_id":"87","village_name":"Khandala Khushal","tehsil_id":"3"},
      {"village_id":"88","village_name":"Khandala Rao","tehsil_id":"3"},
      {"village_id":"89","village_name":"Khari","tehsil_id":"3"},
      {"village_id":"90","village_name":"Khattali Chhoti","tehsil_id":"3"},
      {"village_id":"91","village_name":"Kherwa","tehsil_id":"3"},
      {"village_id":"92","village_name":"Khushal Bardi","tehsil_id":"3"},
      {"village_id":"93","village_name":"khutaja","tehsil_id":"3"},
      {"village_id":"94","village_name":"kila Jobat","tehsil_id":"3"},
      {"village_id":"95","village_name":"Kolya Bayda","tehsil_id":"3"},
      {"village_id":"96","village_name":"Kosduna","tehsil_id":"3"},
      {"village_id":"97","village_name":"Kotada","tehsil_id":"3"},
      {"village_id":"98","village_name":"Kothadi","tehsil_id":"3"},
      {"village_id":"99","village_name":"Kundalwasa","tehsil_id":"3"},
      {"village_id":"100","village_name":"Lachhman Falya","tehsil_id":"3"},
      {"village_id":"101","village_name":"Mahudi","tehsil_id":"3"},
      {"village_id":"102","village_name":"Mandawgarh","tehsil_id":"3"},
      {"village_id":"103","village_name":"Mannakuwa","tehsil_id":"3"},
      {"village_id":"104","village_name":"Mota Umar","tehsil_id":"3"},
      {"village_id":"105","village_name":"Naharpura","tehsil_id":"3"},
      {"village_id":"106","village_name":"Nehtada","tehsil_id":"3"},
      {"village_id":"107","village_name":"Nimthal","tehsil_id":"3"},
      {"village_id":"108","village_name":"Pahadwa","tehsil_id":"3"},
      {"village_id":"109","village_name":"Paneri","tehsil_id":"3"},
      {"village_id":"110","village_name":"Pangola","tehsil_id":"3"},
      {"village_id":"111","village_name":"Patbayadi","tehsil_id":"3"},
      {"village_id":"112","village_name":"Pipalya","tehsil_id":"3"},
      {"village_id":"113","village_name":"Poya","tehsil_id":"3"},
      {"village_id":"114","village_name":"Pratap Falya","tehsil_id":"3"},
      {"village_id":"115","village_name":"Rampura","tehsil_id":"3"},
      {"village_id":"116","village_name":"Ranjeetgarh","tehsil_id":"3"},
      {"village_id":"117","village_name":"Ratanpura","tehsil_id":"3"},
      {"village_id":"118","village_name":"Ratmaliya","tehsil_id":"3"},
      {"village_id":"119","village_name":"Sagota","tehsil_id":"3"},
      {"village_id":"120","village_name":"Salkheda","tehsil_id":"3"},
      {"village_id":"121","village_name":"Semalda","tehsil_id":"3"},
      {"village_id":"122","village_name":"Semalkhedi","tehsil_id":"3"},
      {"village_id":"123","village_name":"Semalpati","tehsil_id":"3"},
      {"village_id":"124","village_name":"Semlaya","tehsil_id":"3"},
      {"village_id":"125","village_name":"Sevad","tehsil_id":"3"},
      {"village_id":"126","village_name":"Sewariya","tehsil_id":"3"},
      {"village_id":"127","village_name":"Sidgoan","tehsil_id":"3"},
      {"village_id":"128","village_name":"Sindi","tehsil_id":"3"},
      {"village_id":"129","village_name":"Siyali","tehsil_id":"3"},
      {"village_id":"130","village_name":"Soliya","tehsil_id":"3"},
      {"village_id":"131","village_name":"Sudi Badi","tehsil_id":"3"},
      {"village_id":"132","village_name":"Sudi Chhoti","tehsil_id":"3"},
      {"village_id":"133","village_name":"Talawad","tehsil_id":"3"},
      {"village_id":"134","village_name":"Temachi","tehsil_id":"3"},
      {"village_id":"135","village_name":"Terka","tehsil_id":"3"},
      {"village_id":"136","village_name":"Thandla","tehsil_id":"3"},
      {"village_id":"137","village_name":"Thapli","tehsil_id":"3"},
      {"village_id":"138","village_name":"Tokria Jharan","tehsil_id":"3"},
      {"village_id":"139","village_name":"Ubgari","tehsil_id":"3"},
      {"village_id":"140","village_name":"Ublad","tehsil_id":"3"},
      {"village_id":"141","village_name":"Udaigarh","tehsil_id":"3"},
      {"village_id":"142","village_name":"Umda","tehsil_id":"3"},
      {"village_id":"143","village_name":"Umeri","tehsil_id":"3"},
      {"village_id":"144","village_name":"Umri","tehsil_id":"3"},
      {"village_id":"145","village_name":"Undri","tehsil_id":"3"},
      {"village_id":"146","village_name":"Uti","tehsil_id":"3"},
      {"village_id":"147","village_name":"Wagdi","tehsil_id":"3"},
      {"village_id":"148","village_name":"Wanjabaida","tehsil_id":"3"},
  ]}

]},
    ],
  },



  

  {
    state_id: "2",
    sortname: "MH",
    state_name: "Maharashtra",
    budget: [
      {
        budgetNo: "1235786",
        Discription:"Maharashtra is a leader among Indian states in terms of agricultural and industrial production, trade and transport, and education. Its ancient culture, at one stage considerably obscured by British dominance, survives largely through the medium of a strong literary heritage",
        image: "images/Maharashtra.png",
        image2: "images/mhlogo.png",
       
      },
    ],
    District: [
      {
        District_id: "1",
        District_name: "Ahmednagar",
        satate_id: "2",
        tehsil: [
          {
            tehsil_id: "1",
            tehsil_name: "Nagar",
            District_id: "1",
            villages: [
              { village_id: "1", village_name: "Agadgaon", tehsil_id: "1" ,village_budget: "12464",},
              { village_id: "2", village_name: "Akolner", tehsil_id: "1" ,village_budget: "12464",},
              { village_id: "3", village_name: "Ambilwadi", tehsil_id: "1",village_budget: "12464", },
              { village_id: "4", village_name: "Arangaon", tehsil_id: "1" ,village_budget: "12464",},
              { village_id: "5", village_name: "Athawad", tehsil_id: "1" ,village_budget: "12464",},
              { village_id: "6", village_name: "Avhadwadi", tehsil_id: "1" ,village_budget: "12464",},
              { village_id: "7", village_name: "Baburdi Ghumat", tehsil_id: "1" ,village_budget: "12464", },
              { village_id: "8", village_name: "BaburdiBend", tehsil_id: "1" ,village_budget: "12464",},
              { village_id: "9", village_name: "Bahirwadi", tehsil_id: "1" ,village_budget: "12464", },
              { village_id: "10", village_name: "Bahirwadi", tehsil_id: "1" ,village_budget: "12464",},
              { village_id: "11", village_name: "	Bara Babhli", tehsil_id: "1" ,village_budget: "12464",},
              { village_id: "12", village_name: "Bardari", tehsil_id: "1",village_budget: "12464", },
              { village_id: "13", village_name: "Bhatodi Pargaon", tehsil_id: "1",village_budget: "12464", },
              { village_id: "14", village_name: "Bhorwadi", tehsil_id: "1",village_budget: "12464", },
              { village_id: "15", village_name: "Bhoyare Kh", tehsil_id: "1",village_budget: "12464",},
              { village_id: "16", village_name: "Bhoyare Pathar", tehsil_id: "1",village_budget: "12464", },
              { village_id: "17", village_name: "Chas", tehsil_id: "1" ,village_budget: "12464",},
              { village_id: "18", village_name: "Chichondi Patil", tehsil_id: "1" ,village_budget: "12464",},
              { village_id: "19", village_name: "Dahigaon", tehsil_id: "1" ,village_budget: "12464",},
              { village_id: "20", village_name: "DashmiGavhan", tehsil_id: "1",village_budget: "12464", },
            ],
          },
          {
            tehsil_id: "2",
            tehsil_name: "Newasa",
            District_id: "1",
            villages: [
              { village_id: "1", village_name: "Amalner", tehsil_id: "2" ,village_budget: "12464",},
              { village_id: "2", village_name: "Antarwali", tehsil_id: "2" ,village_budget: "12464",},
              { village_id: "3", village_name: "Babhulkhede", tehsil_id: "2" ,village_budget: "12464", },
              { village_id: "4", village_name: "Babhulwedhe", tehsil_id: "2" ,village_budget: "12464",},
              { village_id: "5", village_name: "Bahirwadi", tehsil_id: "2" ,village_budget: "12464",},
              { village_id: "6", village_name: "Baku Pimpalgaon", tehsil_id: "2",village_budget: "12464", },
              { village_id: "7", village_name: "Barhanpur", tehsil_id: "2",village_budget: "12464", },
              { village_id: "8", village_name: "Belhekarwadi", tehsil_id: "2",village_budget: "12464", },
              { village_id: "9", village_name: "Belpandhari", tehsil_id: "2",village_budget: "12464", },
              { village_id: "10", village_name: "Belpimpalgaon", tehsil_id: "2" ,village_budget: "12464",},
              { village_id: "11", village_name: "Bhalgaon", tehsil_id: "2",village_budget: "12464", },
              { village_id: "12", village_name: "Bhanashiware", tehsil_id: "2" ,village_budget: "12464",},
              { village_id: "13", village_name: "Bhende Bk.", tehsil_id: "2" ,village_budget: "12464",},
              { village_id: "14", village_name: "Bhende Kh.", tehsil_id: "2" ,village_budget: "12464",},
              { village_id: "15", village_name: "Borgaon", tehsil_id: "2" ,village_budget: "12464",},
              { village_id: "16", village_name: "Chanda", tehsil_id: "2",village_budget: "12464", },
              { village_id: "17", village_name: "Chilekhanwadi", tehsil_id: "2" ,village_budget: "12464",},
              { village_id: "18", village_name: "Chinchban", tehsil_id: "2",village_budget: "12464", },
              { village_id: "19", village_name: "Dedgaon", tehsil_id: "2" ,village_budget: "12464",},
              { village_id: "20", village_name: "Deogaon", tehsil_id: "2",village_budget: "12464", },
            ],
          },
          {
            tehsil_id: "3",
            tehsil_name: "Karjat",
            District_id: "1",
            villages: [
              { village_id: "1", village_name: "Akhoni", tehsil_id: "3" ,village_budget: "12464",},
              { village_id: "2", village_name: "Alsunde", tehsil_id: "3" ,village_budget: "12464",},
              { village_id: "3", village_name: "Ambijalgaon", tehsil_id: "3",village_budget: "12464", },
              { village_id: "4", village_name: "Anandwadi", tehsil_id: "3",village_budget: "12464", },
              { village_id: "5", village_name: "Autewadi", tehsil_id: "3",village_budget: "12464", },
              { village_id: "5", village_name: "Autewadi", tehsil_id: "3",village_budget: "12464", },
              { village_id: "6", village_name: "Babhulgaon Dumala", tehsil_id: "3" ,village_budget: "12464",},
              { village_id: "7", village_name: "Babhulgaon khalsa", tehsil_id: "3",village_budget: "12464", },
              { village_id: "8", village_name: "Bahirobawadi", tehsil_id: "3" ,village_budget: "12464",},
              { village_id: "9", village_name: "Bajrangwadi", tehsil_id: "3" ,village_budget: "12464",},
              { village_id: "10", village_name: "Balwandi", tehsil_id: "3" ,village_budget: "12464",},
              { village_id: "11", village_name: "Baradgaon Dagadi", tehsil_id: "3" ,village_budget: "12464",},
              { village_id: "12", village_name: "Baradgaon Sudrik", tehsil_id: "3" ,village_budget: "12464",},
              { village_id: "13", village_name: "Bargewadi", tehsil_id: "3" ,village_budget: "12464",},
              { village_id: "14", village_name: "Belgaon", tehsil_id: "3" ,village_budget: "12464",},
              { village_id: "15", village_name: "Benwadi", tehsil_id: "3" ,village_budget: "12464",},
              { village_id: "16", village_name: "Berdi", tehsil_id: "3" ,village_budget: "12464",},
              { village_id: "17", village_name: "	Bhambore", tehsil_id: "3" ,village_budget: "12464",},
              { village_id: "18", village_name: "Bhandewadi", tehsil_id: "3" ,village_budget: "12464",},
              { village_id: "19", village_name: "Bhose", tehsil_id: "3" ,village_budget: "12464",},
              { village_id: "20", village_name: "Bitkewadi", tehsil_id: "3" ,village_budget: "12464",},
            ],
          },
          {
            tehsil_id: "4",
            tehsil_name: "Jamkhed",
            District_id: "1",
            villages: [
              { village_id: "1", village_name: "Aghi", tehsil_id: "4" ,village_budget: "12464",},
              { village_id: "2", village_name: "Anandwadi", tehsil_id: "4" ,village_budget: "12464",},
              { village_id: "3", village_name: "Apti", tehsil_id: "4",village_budget: "12464", },
              { village_id: "4", village_name: "Arangaon", tehsil_id: "4",village_budget: "12464", },
              { village_id: "5", village_name: "Balgavhan", tehsil_id: "4",village_budget: "12464", },
              { village_id: "5", village_name: "Bandhkhadak", tehsil_id: "4",village_budget: "12464", },
              { village_id: "6", village_name: "Batewadi", tehsil_id: "4" ,village_budget: "12464",},
              { village_id: "7", village_name: "Bavi", tehsil_id: "4",village_budget: "12464", },
              { village_id: "8", village_name: "Bhavarwadi", tehsil_id: "4" ,village_budget: "12464",},
              { village_id: "9", village_name: "Bhutvada", tehsil_id: "4" ,village_budget: "12464",},
              { village_id: "10", village_name: "Borle", tehsil_id: "4" ,village_budget: "12464",},
              { village_id: "11", village_name: "Chobhewadi", tehsil_id: "4" ,village_budget: "12464",},
              { village_id: "12", village_name: "Chondhi", tehsil_id: "4" ,village_budget: "12464",},
              { village_id: "13", village_name: "Chumbhali", tehsil_id: "4" ,village_budget: "12464",},
              { village_id: "14", village_name: "Daradwadi", tehsil_id: "4" ,village_budget: "12464",},
              { village_id: "15", village_name: "Daundachiwadi", tehsil_id: "4" ,village_budget: "12464",},
              { village_id: "16", village_name: "	Deodaithan", tehsil_id: "4" ,village_budget: "12464",},
              { village_id: "17", village_name: "Dhamangaon", tehsil_id: "4" ,village_budget: "12464",},
              { village_id: "18", village_name: "Dhanegaon", tehsil_id: "4" ,village_budget: "12464",},
              { village_id: "19", village_name: "Dhanora", tehsil_id: "4" ,village_budget: "12464",},
              { village_id: "20", village_name: "Dhond Pargaon", tehsil_id: "4" ,village_budget: "12464",},
              
            ],
          },
          {
            tehsil_id: "5",
            tehsil_name: "Pathardi",
            District_id: "1",
            villages: [
              { village_id: "1", village_name: "Adgaon", tehsil_id: "5" ,village_budget: "12464",},
              { village_id: "2", village_name: "Agaskhand", tehsil_id: "5" ,village_budget: "12464",},
              { village_id: "3", village_name: "Akola", tehsil_id: "5" ,village_budget: "12464",},
              { village_id: "4", village_name: "Alhanwadi", tehsil_id: "5" ,village_budget: "12464",},
              { village_id: "5", village_name: "Ambika Nagar", tehsil_id: "5" ,village_budget: "12464",},
              { village_id: "6", village_name: "Auranjpur", tehsil_id: "5" ,village_budget: "12464",},
              { village_id: "7", village_name: "Badewadi", tehsil_id: "5" ,village_budget: "12464",},
              { village_id: "8", village_name: "Bhalgaon", tehsil_id: "5" ,village_budget: "12464",},
              { village_id: "9", village_name: "Bharajwadi", tehsil_id: "5" ,village_budget: "12464",},
              { village_id: "10", village_name: "Bhawarwadi", tehsil_id: "5" ,village_budget: "12464",},
            ],
          },
          {
            tehsil_id: "6",
            tehsil_name: "Shevgaon",
            District_id: "1",
            villages: [
              { village_id: "1", village_name: "Adhodi", tehsil_id: "6" ,village_budget: "12464",},
              { village_id: "2", village_name: "Akhatwade", tehsil_id: "6" ,village_budget: "12464",},
              { village_id: "3", village_name: "Akhegaon Titarfa", tehsil_id: "6" ,village_budget: "12464",},
              { village_id: "4", village_name: "Amarapur", tehsil_id: "6" ,village_budget: "12464",},
              { village_id: "5", village_name: "Antarwali Bk.", tehsil_id: "6" ,village_budget: "12464",},
              { village_id: "6", village_name: "Antarwali Kh. Ne.", tehsil_id: "6" ,village_budget: "12464",},
              { village_id: "7", village_name: "Antarwali Kh.she", tehsil_id: "6" ,village_budget: "12464",},
              { village_id: "8", village_name: "Antre", tehsil_id: "6" ,village_budget: "12464",},
              { village_id: "9", village_name: "Apegaon", tehsil_id: "6" ,village_budget: "12464",},
              { village_id: "10", village_name: "	Awhane Bk.", tehsil_id: "6" ,village_budget: "12464",},
            ],
          },
          {
            tehsil_id: "7",
            tehsil_name: "Shrigonda",
            District_id: "1",
            villages: [
              { village_id: "1", village_name: "Adhalgaon", tehsil_id: "7" ,village_budget: "12464",},
              { village_id: "2", village_name: "Adhorewadi", tehsil_id: "7" ,village_budget: "12464",},
              { village_id: "3", village_name: "Ajnuj", tehsil_id: "7" ,village_budget: "12464",},
              { village_id: "4", village_name: "Anandwadi", tehsil_id: "7" ,village_budget: "12464",},
              { village_id: "4", village_name: "Angare", tehsil_id: "7" ,village_budget: "12464",},
              { village_id: "5", village_name: "Arangaon Dumala", tehsil_id: "7" ,village_budget: "12464",},
              { village_id: "6", village_name: "Arvi", tehsil_id: "7" ,village_budget: "12464",},
              { village_id: "7", village_name: "Baburdi", tehsil_id: "7" ,village_budget: "12464",},
              { village_id: "8", village_name: "Bangarde", tehsil_id: "7" ,village_budget: "12464",},
              { village_id: "9", village_name: "Banpimpri", tehsil_id: "7" ,village_budget: "12464",},
              { village_id: "10", village_name: "Belwandi Bk.", tehsil_id: "7" ,village_budget: "12464",},
            ],
          },
          {
            tehsil_id: "8",
            tehsil_name: "Parner",
            District_id: "1",
            villages: [
              { village_id: "1", village_name: "Akkalwadi", tehsil_id: "8" ,village_budget: "12464",},
              { village_id: "2", village_name: "Alkuti", tehsil_id: "8" ,village_budget: "12464",},
              { village_id: "3", village_name: "Apdhup", tehsil_id: "8" ,village_budget: "12464",},
              { village_id: "4", village_name: "Astagaon", tehsil_id: "8" ,village_budget: "12464",},
              { village_id: "5", village_name: "Babhulwade", tehsil_id: "8" ,village_budget: "12464",},
              { village_id: "6", village_name: "Baburdi", tehsil_id: "8" ,village_budget: "12464",},
              { village_id: "7", village_name: "Bahirobawadi", tehsil_id: "8" ,village_budget: "12464",},
              { village_id: "8", village_name: "Bhalawani", tehsil_id: "8" ,village_budget: "12464",},
              { village_id: "9", village_name: "Bhandgaon", tehsil_id: "8" ,village_budget: "12464",},
              { village_id: "10", village_name: "Bhangadwadi", tehsil_id: "8" ,village_budget: "12464",},
            ],
          },
          {
            tehsil_id: "9",
            tehsil_name: "Sangamner",
            District_id: "1",
            villages: [
              { village_id: "1", village_name: "Abhalwadi", tehsil_id: "9" ,village_budget: "12464",},
              { village_id: "2", village_name: "Ajampur", tehsil_id: "9" ,village_budget: "12464",},
              { village_id: "3", village_name: "Akalapur", tehsil_id: "9" ,village_budget: "12464",},
              { village_id: "4", village_name: "Ambhore", tehsil_id: "9" ,village_budget: "12464",},
              { village_id: "5", village_name: "Ambi Dumala", tehsil_id: "9" ,village_budget: "12464",},
              { village_id: "6", village_name: "Ambi Khalasa", tehsil_id: "9" ,village_budget: "12464",},
              { village_id: "7", village_name: "Arampur", tehsil_id: "9" ,village_budget: "12464",},
              { village_id: "8", village_name: "Ashwi Bk.", tehsil_id: "9" ,village_budget: "12464",},
              { village_id: "9", village_name: "Ashwi Kh.", tehsil_id: "9" ,village_budget: "12464",},
              { village_id: "10", village_name: "Aurangpur", tehsil_id: "9" ,village_budget: "12464",},
            ],
          },
          {
            tehsil_id: "10",
            tehsil_name: "Akole",
            District_id: "1",
            villages: [
              { village_id: "1", village_name: "Abit Khind", tehsil_id: "10" ,village_budget: "12464",},
              { village_id: "2", village_name: "Agar", tehsil_id: "10" ,village_budget: "12464",},
              { village_id: "3", village_name: "Agastinagar", tehsil_id: "10" ,village_budget: "12464",},
              { village_id: "4", village_name: "Akola", tehsil_id: "10" ,village_budget: "12464",},
              { village_id: "5", village_name: "Ambad", tehsil_id: "10" ,village_budget: "12464",},
              { village_id: "6", village_name: "Ambevangan", tehsil_id: "10" ,village_budget: "12464",},
              { village_id: "7", village_name: "Ambhol", tehsil_id: "10" ,village_budget: "12464",},
              { village_id: "8", village_name: "Ambikanagar", tehsil_id: "10" ,village_budget: "12464",},
              { village_id: "9", village_name: "Ambit", tehsil_id: "10" ,village_budget: "12464",},
              { village_id: "10", village_name: "Aurangpur", tehsil_id: "10" ,village_budget: "12464",},
            ],
          },
          {
            tehsil_id: "11",
            tehsil_name: "Rahata",
            District_id: "1",
            villages: [
              { village_id: "1", village_name: "Adgaon Bk", tehsil_id: "11" ,village_budget: "12464",},
              { village_id: "2", village_name: "Adgaon Kh", tehsil_id: "11" ,village_budget: "12464",},
              { village_id: "3", village_name: "Astagaon", tehsil_id: "11" ,village_budget: "12464",},
              { village_id: "4", village_name: "Babhaleshwar Bk", tehsil_id: "11" ,village_budget: "12464",},
              { village_id: "5", village_name: "Babhaleshwar Kh", tehsil_id: "11" ,village_budget: "12464",},
              { village_id: "6", village_name: "Bhagwatipur", tehsil_id: "11" ,village_budget: "12464",},
              { village_id: "7", village_name: "Chandrapur", tehsil_id: "11" ,village_budget: "12464",},
              { village_id: "8", village_name: "Chitali", tehsil_id: "11" ,village_budget: "12464",},
              { village_id: "9", village_name: "Cholkewadi", tehsil_id: "11" ,village_budget: "12464",},
              { village_id: "10", village_name: "Dadh Bk", tehsil_id: "11" ,village_budget: "12464",},
            ],
          },
          {
            tehsil_id: "12",
            tehsil_name: "Kopargaon",
            District_id: "1",
            villages: [
              { village_id: "1", village_name: "Anchalgaon", tehsil_id: "12" ,village_budget: "12464",},
              { village_id: "2", village_name: "Anjanapur", tehsil_id: "12" ,village_budget: "12464",},
              { village_id: "3", village_name: "Apegaon", tehsil_id: "12" ,village_budget: "12464",},
              { village_id: "4", village_name: "Bahadarbad", tehsil_id: "12" ,village_budget: "12464",},
              { village_id: "5", village_name: "Bahadarpur", tehsil_id: "12" ,village_budget: "12464",},
              { village_id: "6", village_name: "Baktarpur", tehsil_id: "12" ,village_budget: "12464",},
              { village_id: "7", village_name: "Bhojade", tehsil_id: "12" ,village_budget: "12464",},
              { village_id: "8", village_name: "Bolaki", tehsil_id: "12" ,village_budget: "12464",},
              { village_id: "9", village_name: "Bramhangaon", tehsil_id: "12" ,village_budget: "12464",},
              { village_id: "10", village_name: "Chande Kasare", tehsil_id: "12" ,village_budget: "12464",},
            ],
          },
          {
            tehsil_id: "13",
            tehsil_name: "Shrirampur",
            District_id: "1",
            villages: [
              { village_id: "1", village_name: "Ainatpur", tehsil_id: "13" ,village_budget: "12464",},
              { village_id: "2", village_name: "Belapur Bk.", tehsil_id: "13" ,village_budget: "12464",},
              { village_id: "3", village_name: "Belapur Kh.", tehsil_id: "13" ,village_budget: "12464",},
              { village_id: "4", village_name: "Bhairavnathnagar", tehsil_id: "13" ,village_budget: "12464",},
              { village_id: "5", village_name: "Bhamathan", tehsil_id: "13" ,village_budget: "12464",},
              { village_id: "6", village_name: "Bherdapur", tehsil_id: "13" ,village_budget: "12464",},
              { village_id: "7", village_name: "Bhokar", tehsil_id: "13" ,village_budget: "12464",},
              { village_id: "8", village_name: "Bramhangaon Vetal", tehsil_id: "13" ,village_budget: "12464",},
              { village_id: "9", village_name: "Dattanagar", tehsil_id: "13" ,village_budget: "12464",},
              { village_id: "10", village_name: "Dighi", tehsil_id: "13" ,village_budget: "12464",},
            ],
          },
          {
            tehsil_id: "14",
            tehsil_name: "Rahuri",
            District_id: "1",
            villages: [
              { village_id: "1", village_name: "Amalner", tehsil_id: "14" ,village_budget: "12464",},
              { village_id: "2", village_name: "Ambi", tehsil_id: "14" ,village_budget: "12464",},
              { village_id: "3", village_name: "Aradgaon", tehsil_id: "14" ,village_budget: "12464",},
              { village_id: "4", village_name: "Babhulgaon", tehsil_id: "14" ,village_budget: "12464",},
              { village_id: "5", village_name: "Baragaon Nandur", tehsil_id: "14" ,village_budget: "12464",},
              { village_id: "6", village_name: "Bodhegaon", tehsil_id: "14" ,village_budget: "12464",},
              { village_id: "7", village_name: "Bramhangaon Bhand", tehsil_id: "14" ,village_budget: "12464",},
              { village_id: "8", village_name: "Bramhani", tehsil_id: "14" ,village_budget: "12464",},
              { village_id: "9", village_name: "Chandakapur", tehsil_id: "14" ,village_budget: "12464",},
              { village_id: "10", village_name: "Chandegaon", tehsil_id: "14" ,village_budget: "12464",},
            ],
          },
        ],
      },
        {
        District_id: "2",
        District_name: "Akola",
        state_id: "2",
        tehsil: [
          {
            tehsil_id: "1",
            tehsil_name: "Akola",
            District_id: "2",
            villages: [
              { village_id: "1", village_name: "Agar", tehsil_id: "1" ,village_budget:"1240"},
              { village_id: "2", village_name: "Akhatwada", tehsil_id: "1" , village_budget:"2341"},
              { village_id: "3", village_name: "Akkalkot", tehsil_id: "1" ,village_budget:"1240"},
              { village_id: "4", village_name: "Akola (Rural)", tehsil_id: "1" , village_budget:"2341"},
              { village_id: "5", village_name: "Akoli Kh.", tehsil_id: "1" ,village_budget:"1240"},
              { village_id: "6", village_name: "Aliyabad", tehsil_id: "1" , village_budget:"2341"},
              { village_id: "7", village_name: "Amanatpur", tehsil_id: "1" ,village_budget:"1240"},
              { village_id: "8", village_name: "Ambikapur", tehsil_id: "1" , village_budget:"2341"},
              { village_id: "9", village_name: "Anakwadi", tehsil_id: "1" ,village_budget:"1240"},
              { village_id: "10", village_name: "Anvi", tehsil_id: "1" , village_budget:"2341"},
              { village_id: "11", village_name: "Apatapa", tehsil_id: "1" ,village_budget:"1240"},
              { village_id: "12", village_name: "Apoti Bk", tehsil_id: "1" , village_budget:"2341"},
              { village_id: "13", village_name: "Apoti Kh", tehsil_id: "1" ,village_budget:"1240"},
              { village_id: "14", village_name: "Babhulgaon", tehsil_id: "1" , village_budget:"2341"},
              { village_id: "15", village_name: "Badlapur", tehsil_id: "1" ,village_budget:"1240"},
              { village_id: "16", village_name: "Bahadarpur", tehsil_id: "1" , village_budget:"2341"},
              { village_id: "17", village_name: "Bahirkhed", tehsil_id: "1" ,village_budget:"1240"},
              { village_id: "18", village_name: "Bakharabad", tehsil_id: "1" , village_budget:"2341"},
              { village_id: "19", village_name: "Bhamhapuri", tehsil_id: "1" ,village_budget:"1240"},
              { village_id: "20", village_name: "Bhaurad", tehsil_id: "1" , village_budget:"2341"},
             
            ],
          },
          {
            tehsil_id: "2",
            tehsil_name: "Balapur",
            District_id: "2",
            villages: [
              { village_id: "1", village_name: "Adoshi", tehsil_id: "2", village_budget:"7528"},
              { village_id: "2", village_name: "Andura", tehsil_id: "2", village_budget:"7528"},
              { village_id: "3", village_name: "Antri Malkapur", tehsil_id: "2" , village_budget:"9825"},
              { village_id: "4", village_name: "Bahadura", tehsil_id: "2", village_budget:"7528"},
              { village_id: "5", village_name: "Balhadi", tehsil_id: "2" , village_budget:"9825"},
              { village_id: "6", village_name: "Barlinga", tehsil_id: "2", village_budget:"7528"},
              { village_id: "7", village_name: "Batwadi Bk.", tehsil_id: "2" , village_budget:"9825"},
              { village_id: "8", village_name: "Batwadi Kh.", tehsil_id: "2", village_budget:"7528"},
              { village_id: "9", village_name: "Bharatpur", tehsil_id: "2" , village_budget:"9825"},
              { village_id: "10", village_name: "Bhikundkhed", tehsil_id: "2", village_budget:"7528"},
              { village_id: "11", village_name: "Borala", tehsil_id: "2" , village_budget:"9825"},
              { village_id: "12", village_name: "Borgaon Vairale", tehsil_id: "2", village_budget:"7528"},
              { village_id: "13", village_name: "Borwakadi", tehsil_id: "2" , village_budget:"9825"},
              { village_id: "14", village_name: "Chincholi Ganu", tehsil_id: "2", village_budget:"7528"},
              { village_id: "15", village_name: "Dadham Bk.", tehsil_id: "2" , village_budget:"9825"},
              { village_id: "16", village_name: "Dagadkhed", tehsil_id: "2", village_budget:"7528"},
              { village_id: "17", village_name: "Degaon", tehsil_id: "2" , village_budget:"9825"},
              { village_id: "18", village_name: "Dhadi", tehsil_id: "2", village_budget:"7528"},
              { village_id: "19", village_name: "Dhanegaon", tehsil_id: "2" , village_budget:"9825"},
              { village_id: "20", village_name: "Dhanora", tehsil_id: "2", village_budget:"7528"},
            ],
          },
          {
            tehsil_id: "3",
            tehsil_name: "Patur",
            District_id: "2",
            villages: [
              { village_id: "1", village_name: "Adgaon Kh.", tehsil_id: "3" , village_budget:"7632"},
              { village_id: "2", village_name: "Agikhed", tehsil_id: "3" ,village_budget:"7632"},
              { village_id: "3", village_name: "Alegaon", tehsil_id: "3" , village_budget:"7632"},
              { village_id: "4", village_name: "Ambasi", tehsil_id: "3" ,village_budget:"7632"},
              { village_id: "5", village_name: "Andhar Sangvi", tehsil_id: "3" , village_budget:"7632"},
              { village_id: "6", village_name: "Asola", tehsil_id: "3" ,village_budget:"7632"},
              { village_id: "7", village_name: "Astul", tehsil_id: "3" , village_budget:"7632"},
              { village_id: "8", village_name: "Babhali", tehsil_id: "3" ,village_budget:"7632"},
              { village_id: "9", village_name: "Babhulgaon", tehsil_id: "3" , village_budget:"7632"},
              { village_id: "10", village_name: "Bagayat Patur", tehsil_id: "3" ,village_budget:"7632"},
    
            ],
          },
          {
            tehsil_id: "4",
            tehsil_name: "Barshitakali",
            District_id: "2",
            villages: [
                { village_id: "1", village_name: "Ajani Kh.", tehsil_id: "4" , village_budget:"3921"},
                { village_id: "2", village_name: "Alanda", tehsil_id: "4" , village_budget:"3921" },
                { village_id: "3", village_name: "Anjani Bk.", tehsil_id: "4" , village_budget:"3921"},
                { village_id: "4", village_name: "Bahirkhed", tehsil_id: "4" , village_budget:"3921" },
                { village_id: "5", village_name: "Barshi Takali", tehsil_id: "4" , village_budget:"3921"},
                { village_id: "6", village_name: "	Bhambora", tehsil_id: "4" , village_budget:"3921" },
                { village_id: "7", village_name: "Bhendgaon", tehsil_id: "4" , village_budget:"3921"},
                { village_id: "8", village_name: "Bhendi Kaji", tehsil_id: "4" , village_budget:"3921" },
                { village_id: "9", village_name: "Bhendi Mahala", tehsil_id: "4" , village_budget:"3921"},
                { village_id: "10", village_name: "	Bhendi Sutrak", tehsil_id: "4" , village_budget:"3921" },
            ],
          },
          {
            tehsil_id: "5",
            tehsil_name: "Murtizapur",
            District_id: "2",
            villages: [
                { village_id: "1", village_name: "Akoli Jaha", tehsil_id: "5",village_budget:"7832" },
                { village_id: "2", village_name: "Aledatpur",  tehsil_id: "5",village_budget:"7832" },
                { village_id: "3", village_name: "Amatwada",   tehsil_id: "5",village_budget:"7832" },
                { village_id: "4", village_name: "Anbhora",    tehsil_id: "5",village_budget:"7832" },
                { village_id: "5", village_name: "Arkhed",     tehsil_id: "5",village_budget:"7832" },
                { village_id: "6", village_name: "Atkali.",    tehsil_id: "5",village_budget:"7832" },
                { village_id: "7", village_name: "Aurangpur",  tehsil_id: "5",village_budget:"7832" },
                { village_id: "8", village_name: "Balapur",    tehsil_id: "5",village_budget:"7832" },
                { village_id: "9", village_name: "Balla Khed", tehsil_id: "5",village_budget:"7832" },
                { village_id: "10", village_name: "Bapori",    tehsil_id: "5",village_budget:"7832" },
            ],
          },
          {
            tehsil_id: "6",
            tehsil_name: "Akot",
            District_id: "2",
            villages: [
              { village_id: "1", village_name: "Adgaon Kh", tehsil_id: "6",village_budget:"7832"  },
              { village_id: "2", village_name: "Agaskhed", tehsil_id: "6" ,village_budget:"7832" },
              { village_id: "3", village_name: "Akoli Jahangir", tehsil_id: "6" ,village_budget:"7832" },
              { village_id: "4", village_name: "Akolkhed", tehsil_id: "6" ,village_budget:"7832" },
              { village_id: "5", village_name: "Alegaon", tehsil_id: "6" ,village_budget:"7832" },
              { village_id: "6", village_name: "Alewadi", tehsil_id: "6" ,village_budget:"7832" },
              { village_id: "7", village_name: "Ambadi", tehsil_id: "6" ,village_budget:"7832" },
              { village_id: "8", village_name: "Amboda", tehsil_id: "6" ,village_budget:"7832"  },
              { village_id: "9", village_name:  "Aminapur", tehsil_id: "6" ,village_budget:"7832" },
              { village_id: "10", village_name: "Asegaon Bajar", tehsil_id: "6" ,village_budget:"7832" },
            ],
          },
          {
            tehsil_id: "7",
            tehsil_name: "Telhara",
            District_id: "2",
            villages: [
              { village_id: "1", village_name: "Adgaon Bk.", tehsil_id: "7" ,village_budget:"2382"},
              { village_id: "2", village_name: "Adsul", tehsil_id: "7" ,village_budget:"2382"},
              { village_id: "3", village_name: "Akoli Ruprao", tehsil_id: "7" ,village_budget:"2382"},
              { village_id: "4", village_name: "Atkali", tehsil_id: "7" ,village_budget:"2382"},
              { village_id: "5", village_name: "Babhulgaon", tehsil_id: "7" ,village_budget:"2382"},
              { village_id: "6", village_name: "Badkhed", tehsil_id: "7" ,village_budget:"2382"},
              { village_id: "7", village_name: "Belkhed", tehsil_id: "7" ,village_budget:"2382"},
              { village_id: "8", village_name: "Bhamberi", tehsil_id: "7" ,village_budget:"2382"},
              { village_id: "9", village_name: "Bhili", tehsil_id: "7" ,village_budget:"2382"},
              { village_id: "10", village_name: "Bhokar", tehsil_id: "7" ,village_budget:"2382"},
            ],
          },]
        },
        {
          District_id: "3",
          District_name: "Amravati",
          state_id: "2",
          tehsil: [
            {
              tehsil_id: "1",
              tehsil_name: "Achalpur",
              District_id: "3",
              villages: [
                { village_id: "1", village_name: "Ajitpur", tehsil_id: "1",village_budget: "12464"},
                { village_id: "2", village_name: "Ambada Kandari", tehsil_id: "1",village_budget: "12464"},
                { village_id: "3", village_name: "Ambuj", tehsil_id: "1",village_budget: "12464"},
                { village_id: "4", village_name: "Antargaon", tehsil_id: "1",village_budget: "12464"},
                { village_id: "5", village_name: "Aregaon", tehsil_id: "1",village_budget: "12464"},
                { village_id: "6", village_name: "Asatpur", tehsil_id: "1",village_budget: "12464"},
                { village_id: "7", village_name: "Aurangpur", tehsil_id: "1",village_budget: "12464"},
                { village_id: "8", village_name: "Bag Ambada", tehsil_id: "1",village_budget: "12464"},
                { village_id: "9", village_name: "Bajitpur", tehsil_id: "1",village_budget: "12464"},
                { village_id: "10", village_name: "Balegaon", tehsil_id: "1",village_budget: "12464"},
                { village_id: "11", village_name: "	Belkheda", tehsil_id: "1",village_budget: "12464"},
                { village_id: "12", village_name: "Beni", tehsil_id: "1",village_budget: "12464"},
                { village_id: "13", village_name: "Bhilona", tehsil_id: "1",village_budget: "12464"},
                { village_id: "14", village_name: "Bhitkheda", tehsil_id: "1",village_budget: "12464"},
                { village_id: "15", village_name: "Bhopapur", tehsil_id: "1",village_budget: "12464"},
                { village_id: "16", village_name: "Bhugaon", tehsil_id: "1",village_budget: "12464"},
                { village_id: "17", village_name: "Bordi", tehsil_id: "1",village_budget: "12464"},
                { village_id: "18", village_name: "	Borgaon Dori", tehsil_id: "1",village_budget: "12464"},
                { village_id: "19", village_name: "Borgaon Peth", tehsil_id: "1",village_budget: "12464"},
                { village_id: "20", village_name: "Borgaon Talni", tehsil_id: "1",village_budget: "12464"}
              ],
            },
            {
              tehsil_id: "2",
              tehsil_name: "Amravati",
              District_id: "3",
              villages: [
                { village_id: "1", village_name: "Aliyabad", tehsil_id: "2",village_budget: "12464"},
                { village_id: "2", village_name: "Amannapur", tehsil_id: "2",village_budget: "12464"},
                { village_id: "3", village_name: "Amdapur", tehsil_id: "2",village_budget: "12464"},
                { village_id: "4", village_name: "Amla", tehsil_id: "2",village_budget: "12464"},
                { village_id: "5", village_name: "Angoda", tehsil_id: "2",village_budget: "12464"},
                { village_id: "6", village_name: "Anjangaon Bari", tehsil_id: "2",village_budget: "12464"},
                { village_id: "7", village_name: "Antora", tehsil_id: "2",village_budget: "12464"},
                { village_id: "8", village_name: "Arhad", tehsil_id: "2",village_budget: "12464"},
                { village_id: "9", village_name: "Aurangpur", tehsil_id: "2",village_budget: "12464"},
                { village_id: "10", village_name: "Bahilolpur", tehsil_id: "2",village_budget: "12464"},
                { village_id: "11", village_name: "Bhagvanpur", tehsil_id: "2",village_budget: "12464"},
                { village_id: "12", village_name: "Bhankheda Bk", tehsil_id: "2",village_budget: "12464"},
                { village_id: "13", village_name: "Bhankheda Kh", tehsil_id: "2",village_budget: "12464"},
                { village_id: "14", village_name: "Bharatpur", tehsil_id: "2",village_budget: "12464"},
                { village_id: "15", village_name: "Bodna", tehsil_id: "2",village_budget: "12464"},
                { village_id: "16", village_name: "Borgaon", tehsil_id: "2",village_budget: "12464"},
                { village_id: "17", village_name: "Brahman Wada Govindpur", tehsil_id: "2",village_budget: "12464"},
                { village_id: "18", village_name: "Bramhanwada Bhagat", tehsil_id: "2",village_budget: "12464"},
                { village_id: "19", village_name: "Chanduri", tehsil_id: "2",village_budget: "12464"},
                { village_id: "20", village_name: "Changapur", tehsil_id: "2",village_budget: "12464"}
              ],
            },
            {
              tehsil_id: "3",
              tehsil_name: "Anjangaon Surji",
              District_id: "3",
              villages: [
                { village_id: "1", village_name: "Adgao", tehsil_id: "3",village_budget: "12464"},
                { village_id: "2", village_name: "Adgaon Ade", tehsil_id: "3",village_budget: "12464"},
                { village_id: "3", village_name: "Ahmadpur", tehsil_id: "3",village_budget: "12464"},
                { village_id: "4", village_name: "Aiwajpur", tehsil_id: "3",village_budget: "12464"},
                { village_id: "5", village_name: "Ajitpur", tehsil_id: "3",village_budget: "12464"},
                { village_id: "6", village_name: "Alampur", tehsil_id: "3",village_budget: "12464"},
                { village_id: "7", village_name: "Alipur", tehsil_id: "3",village_budget: "12464"},
                { village_id: "8", village_name: "Aurangpur", tehsil_id: "3",village_budget: "12464"},
                { village_id: "9", village_name: "Bhandaraj", tehsil_id: "3",village_budget: "12464"},
                { village_id: "10", village_name: "Bhokari", tehsil_id: "3",village_budget: "12464"},
                { village_id: "11", village_name: "Bhuraskheda", tehsil_id: "3",village_budget: "12464"},
                { village_id: "12", village_name: "Borala", tehsil_id: "3",village_budget: "12464"},
                { village_id: "13", village_name: "Borgaon Ambada", tehsil_id: "3",village_budget: "12464"},
                { village_id: "14", village_name: "Bramhanwada", tehsil_id: "3",village_budget: "12464"},
                { village_id: "15", village_name: "Chausala", tehsil_id: "3",village_budget: "12464"},
                { village_id: "16", village_name: "Chincholi Bk", tehsil_id: "3",village_budget: "12464"},
                { village_id: "17", village_name: "Chincholi Kh", tehsil_id: "3",village_budget: "12464"},
                { village_id: "18", village_name: "Chincholi Shingne", tehsil_id: "3",village_budget: "12464"},
                { village_id: "19", village_name: "Chinchona", tehsil_id: "3",village_budget: "12464"},
                { village_id: "20", village_name: "Dahigaon Bk", tehsil_id: "3",village_budget: "12464"}
              ],
            },
            {
              tehsil_id: "4",
              tehsil_name: "Bhatkuli",
              District_id: "3",
              villages: [
                { village_id: "1", village_name: "Abitpur", tehsil_id: "4",village_budget: "12464"},
                { village_id: "2", village_name: "Advi", tehsil_id: "4",village_budget: "12464"},
                { village_id: "3", village_name: "Afjalpur", tehsil_id: "4",village_budget: "12464"},
                { village_id: "4", village_name: "Alangaon", tehsil_id: "4",village_budget: "12464"},
                { village_id: "5", village_name: "Anchalwadi", tehsil_id: "4",village_budget: "12464"},
                { village_id: "6", village_name: "Antapur", tehsil_id: "4",village_budget: "12464"},
                { village_id: "7", village_name: "Asara", tehsil_id: "4",village_budget: "12464"},
                { village_id: "8", village_name: "Ashti", tehsil_id: "4",village_budget: "12464"},
                { village_id: "9", village_name: "Badegaon", tehsil_id: "4",village_budget: "12464"},
                { village_id: "10", village_name: "Bahaddarpur", tehsil_id: "4",village_budget: "12464"}
              ],
            },
            {
              tehsil_id: "5",
              tehsil_name: "Chandur Railway",
              District_id: "3",
              villages: [
                { village_id: "1", village_name: "Ajitpur", tehsil_id: "5",village_budget: "12464"},
                { village_id: "2", village_name: "Ambapur", tehsil_id: "5",village_budget: "12464"},
                { village_id: "3", village_name: "Amdori", tehsil_id: "5",village_budget: "12464"},
                { village_id: "4", village_name: "Amla Vishveshwar", tehsil_id: "5",village_budget: "12464"},
                { village_id: "5", village_name: "Ashrafpur", tehsil_id: "5",village_budget: "12464"},
                { village_id: "6", village_name: "Bagapur", tehsil_id: "5",village_budget: "12464"},
                { village_id: "7", village_name: "Baggi", tehsil_id: "5",village_budget: "12464"},
                { village_id: "8", village_name: "Baslapur", tehsil_id: "5",village_budget: "12464"},
                { village_id: "9", village_name: "Bhiltek", tehsil_id: "5",village_budget: "12464"},
                { village_id: "10", village_name: "Bori", tehsil_id: "5",village_budget: "12464"}
              ],
            },
            {
              tehsil_id: "6",
              tehsil_name: "Chandurbazar",
              District_id: "3",
              villages: [
                { village_id: "1", village_name: "Afzalpur", tehsil_id: "6",village_budget: "12464"},
                { village_id: "2", village_name: "Alipur", tehsil_id: "6",village_budget: "12464"},
                { village_id: "3", village_name: "Asegaon", tehsil_id: "6",village_budget: "12464"},
                { village_id: "4", village_name: "Belkheda", tehsil_id: "6",village_budget: "12464"},
                { village_id: "5", village_name: "Belura", tehsil_id: "6",village_budget: "12464"},
                { village_id: "6", village_name: "Bhangaon", tehsil_id: "6",village_budget: "12464"},
                { village_id: "7", village_name: "Borala", tehsil_id: "6",village_budget: "12464"},
                { village_id: "8", village_name: "Bramhanwada Thadi", tehsil_id: "6",village_budget: "12464"},
                { village_id: "9", village_name: "Chincholi kale", tehsil_id: "6",village_budget: "12464"},
                { village_id: "10", village_name: "Dattapur", tehsil_id: "6",village_budget: "12464"}
              ],
            },
            {
              tehsil_id: "7",
              tehsil_name: "Chikhaldara",
              District_id: "3",
              villages: [
                { village_id: "1", village_name: "Adhav", tehsil_id: "7",village_budget: "12464"},
                { village_id: "2", village_name: "Adnadi", tehsil_id: "7",village_budget: "12464"},
                { village_id: "3", village_name: "Ahad", tehsil_id: "7",village_budget: "12464"},
                { village_id: "4", village_name: "Aki", tehsil_id: "7",village_budget: "12464"},
                { village_id: "5", village_name: "Aladoh", tehsil_id: "7",village_budget: "12464"},
                { village_id: "6", village_name: "Ambapati", tehsil_id: "7",village_budget: "12464"},
                { village_id: "7", village_name: "Amona", tehsil_id: "7",village_budget: "12464"},
                { village_id: "8", village_name: "Amzari", tehsil_id: "7",village_budget: "12464"},
                { village_id: "9", village_name: "Asalwada", tehsil_id: "7",village_budget: "12464"},
                { village_id: "10", village_name: "Awagad", tehsil_id: "7",village_budget: "12464"}
              ],
            },
            {
              tehsil_id: "8",
              tehsil_name: "Daryapur",
              District_id: "3",
              villages: [
                { village_id: "1", village_name: "Adula", tehsil_id: "8",village_budget: "12464"},
                { village_id: "2", village_name: "Ahmadpur", tehsil_id: "8",village_budget: "12464"},
                { village_id: "3", village_name: "Ajitpur", tehsil_id: "8",village_budget: "12464"},
                { village_id: "4", village_name: "Alampur", tehsil_id: "8",village_budget: "12464"},
                { village_id: "5", village_name: "Amla", tehsil_id: "8",village_budget: "12464"},
                { village_id: "6", village_name: "Antargaon", tehsil_id: "8",village_budget: "12464"},
                { village_id: "7", village_name: "Arala", tehsil_id: "8",village_budget: "12464"},
                { village_id: "8", village_name: "Babhali", tehsil_id: "8",village_budget: "12464"},
                { village_id: "9", village_name: "Bahadarpur", tehsil_id: "8",village_budget: "12464"},
                { village_id: "10", village_name: "Banosa", tehsil_id: "8",village_budget: "12464"}
              ],
            },
            {
              tehsil_id: "9",
              tehsil_name: "Dhamangaon Railway",
              District_id: "3",
              villages: [
                { village_id: "1", village_name: "Amadabad", tehsil_id: "9",village_budget: "12464"},
                { village_id: "2", village_name: "Anjangaon", tehsil_id: "9",village_budget: "12464"},
                { village_id: "3", village_name: "Anjansingi", tehsil_id: "9",village_budget: "12464"},
                { village_id: "4", village_name: "Anjanwati", tehsil_id: "9",village_budget: "12464"},
                { village_id: "5", village_name: "Asegaon", tehsil_id: "9",village_budget: "12464"},
                { village_id: "6", village_name: "Ashok Nagar", tehsil_id: "9",village_budget: "12464"},
                { village_id: "7", village_name: "Ashta", tehsil_id: "9",village_budget: "12464"},
                { village_id: "8", village_name: "Bahirampur", tehsil_id: "9",village_budget: "12464"},
                { village_id: "9", village_name: "Barhanpur", tehsil_id: "9",village_budget: "12464"},
                { village_id: "10", village_name: "Bhatkuli", tehsil_id: "9",village_budget: "12464"}
              ],
            },
            {
              tehsil_id: "10",
              tehsil_name: "Dharni",
              District_id: "3",
              villages: [
                { village_id: "1", village_name: "Aki", tehsil_id: "10",village_budget: "12464"},
                { village_id: "2", village_name: "Ambadi", tehsil_id: "10",village_budget: "12464"},
                { village_id: "3", village_name: "Babanda", tehsil_id: "10",village_budget: "12464"},
                { village_id: "4", village_name: "Bairagad", tehsil_id: "10",village_budget: "12464"},
                { village_id: "5", village_name: "Baratanda", tehsil_id: "10",village_budget: "12464"},
                { village_id: "6", village_name: "Baru", tehsil_id: "10",village_budget: "12464"},
                { village_id: "7", village_name: "Baspani", tehsil_id: "10",village_budget: "12464"},
                { village_id: "8", village_name: "Bazardhana", tehsil_id: "10",village_budget: "12464"},
                { village_id: "9", village_name: "Berdabarda", tehsil_id: "10",village_budget: "12464"},
                { village_id: "10", village_name: "Berdabhuru", tehsil_id: "10",village_budget: "12464"}
              ],
            },
            {
              tehsil_id: "11",
              tehsil_name: "Morshi",
              District_id: "3",
              villages: [
                { village_id: "1", village_name: "Adgaon", tehsil_id: "11",village_budget: "12464"},
                { village_id: "2", village_name: "Ahmadabad", tehsil_id: "11",village_budget: "12464"},
                { village_id: "3", village_name: "Ahmadpur", tehsil_id: "11",village_budget: "12464"},
                { village_id: "4", village_name: "Ajampur", tehsil_id: "11",village_budget: "12464"},
                { village_id: "5", village_name: "Akhatwada", tehsil_id: "11",village_budget: "12464"},
                { village_id: "6", village_name: "Ambada", tehsil_id: "11",village_budget: "12464"},
                { village_id: "7", village_name: "Ambhori", tehsil_id: "11",village_budget: "12464"},
                { village_id: "8", village_name: "Ashtagaon", tehsil_id: "11",village_budget: "12464"},
                { village_id: "9", village_name: "Ashtoli", tehsil_id: "11",village_budget: "12464"},
                { village_id: "10", village_name: "Asona", tehsil_id: "11",village_budget: "12464"}
              ],
            },
            {
              tehsil_id: "12",
              tehsil_name: "Nandgaon Khandeshwar",
              District_id: "3",
              villages: [
                { village_id: "1", village_name: "Adgaon Bk", tehsil_id: "12",village_budget: "12464"},
                { village_id: "2", village_name: "Adgaon Kh", tehsil_id: "12",village_budget: "12464"},
                { village_id: "3", village_name: "Aditapur", tehsil_id: "12",village_budget: "12464"},
                { village_id: "4", village_name: "Ajani", tehsil_id: "12",village_budget: "12464"},
                { village_id: "5", village_name: "Ajmatpur", tehsil_id: "12",village_budget: "12464"},
                { village_id: "6", village_name: "Amdapur", tehsil_id: "12",village_budget: "12464"},
                { village_id: "7", village_name: "Arjunpur", tehsil_id: "12",village_budget: "12464"},
                { village_id: "8", village_name: "Bachharapur", tehsil_id: "12",village_budget: "12464"},
                { village_id: "9", village_name: "Bakhalapur", tehsil_id: "12",village_budget: "12464"},
                { village_id: "10", village_name: "Belora", tehsil_id: "12",village_budget: "12464"}
              ],
            },
            {
              tehsil_id: "13",
              tehsil_name: "Teosa",
              District_id: "3",
              villages: [
                { village_id: "1", village_name: "Akhatwada", tehsil_id: "13",village_budget: "12464"},
                { village_id: "2", village_name: "Alwada", tehsil_id: "13",village_budget: "12464"},
                { village_id: "3", village_name: "Amdabad", tehsil_id: "13",village_budget: "12464"},
                { village_id: "4", village_name: "Ankwadi", tehsil_id: "13",village_budget: "12464"},
                { village_id: "5", village_name: "Bhambora", tehsil_id: "13",village_budget: "12464"},
                { village_id: "6", village_name: "Bharaswadi", tehsil_id: "13",village_budget: "12464"},
                { village_id: "7", village_name: "Bharwadi", tehsil_id: "13",village_budget: "12464"},
                { village_id: "8", village_name: "Bhiwapur", tehsil_id: "13",village_budget: "12464"},
                { village_id: "9", village_name: "Borda", tehsil_id: "13",village_budget: "12464"},
                { village_id: "10", village_name: "Chandur Dhore", tehsil_id: "13",village_budget: "12464"}
              ],
            },
            {
              tehsil_id: "14",
              tehsil_name: "Warud",
              District_id: "3",
              villages: [
                { village_id: "1", village_name: "Ajitpur Bhapki", tehsil_id: "14",village_budget: "12464"},
                { village_id: "2", village_name: "Aloda", tehsil_id: "14",village_budget: "12464"},
                { village_id: "3", village_name: "Ambafata", tehsil_id: "14",village_budget: "12464"},
                { village_id: "4", village_name: "Ambpend", tehsil_id: "14",village_budget: "12464"},
                { village_id: "5", village_name: "Amdapur", tehsil_id: "14",village_budget: "12464"},
                { village_id: "6", village_name: "Amner", tehsil_id: "14",village_budget: "12464"},
                { village_id: "7", village_name: "Antarkhop", tehsil_id: "14",village_budget: "12464"},
                { village_id: "8", village_name: "Asona", tehsil_id: "14",village_budget: "12464"},
                { village_id: "9", village_name: "Babhulkheda", tehsil_id: "14",village_budget: "12464"},
                { village_id: "10", village_name: "Bahada", tehsil_id: "14",village_budget: "12464"}
              ],
           },
      ],
  },
      // {
      //   District_id: "4",
      //   District_name: "Aurangabad",
      //   state_id: "2",
      //   tehsil: [
      //     {
      //       tehsil_id: "1",
      //       tehsil_name: "Aurangabad",
      //       District_id: "4",
      //       villages: [
      //         { village_id: "1", village_name: "", tehsil_id: "1" },
      //         { village_id: "2", village_name: "", tehsil_id: "1" },
      //       ],
      //     },
      //     {
      //       tehsil_id: "2",
      //       tehsil_name: "Sillod",
      //       District_id: "4",
      //       villages: [
      //         { village_id: "1", village_name: "", tehsil_id: "2" },
      //         { village_id: "2", village_name: "", tehsil_id: "2" },
      //       ],
      //     },
      //     {
      //       tehsil_id: "3",
      //       tehsil_name: "Soegaon",
      //       District_id: "4",
      //       villages: [
      //         { village_id: "1", village_name: "", tehsil_id: "3" },
      //         { village_id: "2", village_name: "", tehsil_id: "3" },
      //       ],
      //     },
      //     {
      //       tehsil_id: "4",
      //       tehsil_name: "Vaijapur",
      //       District_id: "4",
      //       villages: [
      //         { village_id: "1", village_name: "", tehsil_id: "4" },
      //         { village_id: "2", village_name: "", tehsil_id: "4" },
      //       ],
      //     },
      //     {
      //       tehsil_id: "5",
      //       tehsil_name: "Gangapur",
      //       District_id: "4",
      //       villages: [
      //         { village_id: "1", village_name: "", tehsil_id: "5" },
      //         { village_id: "2", village_name: "", tehsil_id: "5" },
      //       ],
      //     },
      //     {
      //       tehsil_id: "6",
      //       tehsil_name: "Paithan",
      //       District_id: "4",
      //       villages: [
      //         { village_id: "1", village_name: "", tehsil_id: "6" },
      //         { village_id: "2", village_name: "", tehsil_id: "6" },
      //       ],
      //     },
      //     {
      //       tehsil_id: "7",
      //       tehsil_name: "Phulambri",
      //       District_id: "4",
      //       villages: [
      //         { village_id: "1", village_name: "", tehsil_id: "7" },
      //         { village_id: "2", village_name: "", tehsil_id: "7" },
      //       ],
      //     },
      //     {
      //       tehsil_id: "8",
      //       tehsil_name: "Kannad",
      //       District_id: "4",
      //       villages: [
      //         { village_id: "1", village_name: "", tehsil_id: "8" },
      //         { village_id: "2", village_name: "", tehsil_id: "8" },
      //       ],
      //     },
      //     {
      //       tehsil_id: "9",
      //       tehsil_name: "Khultabad",
      //       District_id: "4",
      //       villages: [
      //         { village_id: "1", village_name: "", tehsil_id: "9" },
      //         { village_id: "2", village_name: "", tehsil_id: "9" },
      //       ],
      //     },
      //   ],
      // },
      // {
      //   District_id: "5",
      //   District_name: "Beed",
      //   state_id: "2",
      //   tehsil: [
      //     {
      //       tehsil_id: "1",
      //       tehsil_name: "Beed",
      //       District_id: "5",
      //       villages: [
      //         { village_id: "1", village_name: "", tehsil_id: "1" },
      //         { village_id: "2", village_name: "", tehsil_id: "1" },
      //       ],
      //     },
      //     {
      //       tehsil_id: "2",
      //       tehsil_name: "Gevrai",
      //       District_id: "5",
      //       villages: [
      //         { village_id: "1", village_name: "", tehsil_id: "2" },
      //         { village_id: "2", village_name: "", tehsil_id: "2" },
      //       ],
      //     },
      //     {
      //       tehsil_id: "3",
      //       tehsil_name: "Majalgaon",
      //       District_id: "5",
      //       villages: [
      //         { village_id: "1", village_name: "", tehsil_id: "3" },
      //         { village_id: "2", village_name: "", tehsil_id: "3" },
      //       ],
      //     },
      //     {
      //       tehsil_id: "4",
      //       tehsil_name: "Dharur",
      //       District_id: "5",
      //       villages: [
      //         { village_id: "1", village_name: "", tehsil_id: "4" },
      //         { village_id: "2", village_name: "", tehsil_id: "4" },
      //       ],
      //     },
      //     {
      //       tehsil_id: "5",
      //       tehsil_name: "Wadwani",
      //       District_id: "5",
      //       villages: [
      //         { village_id: "1", village_name: "", tehsil_id: "5" },
      //         { village_id: "2", village_name: "", tehsil_id: "5" },
      //       ],
      //     },
      //     {
      //       tehsil_id: "6",
      //       tehsil_name: "Wadwani",
      //       District_id: "5",
      //       villages: [
      //         { village_id: "1", village_name: "", tehsil_id: "6" },
      //         { village_id: "2", village_name: "", tehsil_id: "6" },
      //       ],
      //     },
      //     {
      //       tehsil_id: "7",
      //       tehsil_name: "Patoda",
      //       District_id: "5",
      //       villages: [
      //         { village_id: "1", village_name: "", tehsil_id: "7" },
      //         { village_id: "2", village_name: "", tehsil_id: "7" },
      //       ],
      //     },
      //     {
      //       tehsil_id: "8",
      //       tehsil_name: "Ashti",
      //       District_id: "5",
      //       villages: [
      //         { village_id: "1", village_name: "", tehsil_id: "8" },
      //         { village_id: "2", village_name: "", tehsil_id: "8" },
      //       ],
      //     },
      //     {
      //       tehsil_id: "9",
      //       tehsil_name: "Shirur Kasar",
      //       District_id: "5",
      //       villages: [
      //         { village_id: "1", village_name: "", tehsil_id: "9" },
      //         { village_id: "2", village_name: "", tehsil_id: "9" },
      //       ],
      //     },
      //     {
      //       tehsil_id: "10",
      //       tehsil_name: "Ambajogai ",
      //       District_id: "5",
      //       villages: [
      //         { village_id: "1", village_name: "", tehsil_id: "10" },
      //         { village_id: "2", village_name: "", tehsil_id: "10 " },
      //       ],
      //     },
      //     {
      //       tehsil_id: "11",
      //       tehsil_name: "Kaij",
      //       District_id: "5",
      //       villages: [
      //         { village_id: "1", village_name: "", tehsil_id: "11" },
      //         { village_id: "2", village_name: "", tehsil_id: "11" },
      //       ],
      //     },
      //   ],
      // },
    // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>End of District Data<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
      // {
      //   District_id: "6",
      //   District_name: "Bhandara",
      //   state_id: "1",
      //   tehsil: [
      //     {
      //       tehsil_id: "1",
      //       tehsil_name: "anjad",
      //       District_id: "2",
      //       villages: [
      //         { village_id: "1", village_name: "hello", tehsil_id: "1" },
      //         { village_id: "2", village_name: "khushi", tehsil_id: "1" },
      //       ],
      //     },
      //     {
      //       tehsil_id: "2",
      //       tehsil_name: "thikri",
      //       District_id: "1",
      //       villages: [
      //         { village_id: "1", village_name: "hiii", tehsil_id: "2" },
      //         { village_id: "2", village_name: "hi", tehsil_id: "2" },
      //       ],
      //     },
      //   ],
      // },
  //     {
  //       District_id: "7",
  //       District_name: "Buldhana",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "8",
  //       District_name: "Chandrapur",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "9",
  //       District_name: "Dhule",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "10",
  //       District_name: "Gadchiroli",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "11",
  //       District_name: "Gondia",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "12",
  //       District_name: "Hingoli",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "13",
  //       District_name: "Jalgaon",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "14",
  //       District_name: "Jalna",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "15",
  //       District_name: "Kolhapur",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "16",
  //       District_name: "Latur",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "17",
  //       District_name: "Mumbai City",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "18",
  //       District_name: "Mumbai Suburban",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "19",
  //       District_name: "Nagpur",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "20",
  //       District_name: "Nanded",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "21",
  //       District_name: "Nandurbar",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "22",
  //       District_name: "Nashik",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "23",
  //       District_name: "Osmanabad",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "24",
  //       District_name: "Palghar",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "25",
  //       District_name: "Parbhani",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "26",
  //       District_name: "Pune",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "27",
  //       District_name: "Raigad",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "28",
  //       District_name: "Ratnagiri",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "29",
  //       District_name: "Sangli",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "30",
  //       District_name: "Satara",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "31",
  //       District_name: "Sindhudurg",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "32",
  //       District_name: "Solapur",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "33",
  //       District_name: "Thane",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "34",
  //       District_name: "Wardha",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "35",
  //       District_name: "Washim",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       District_id: "36",
  //       District_name: "Yavatmal",
  //       state_id: "1",
  //       tehsil: [
  //         {
  //           tehsil_id: "1",
  //           tehsil_name: "anjad",
  //           District_id: "2",
  //           villages: [
  //             { village_id: "1", village_name: "hello", tehsil_id: "1" },
  //             { village_id: "2", village_name: "khushi", tehsil_id: "1" },
  //           ],
  //         },
  //         {
  //           tehsil_id: "2",
  //           tehsil_name: "thikri",
  //           District_id: "1",
  //           villages: [
  //             { village_id: "1", village_name: "hiii", tehsil_id: "2" },
  //             { village_id: "2", village_name: "hi", tehsil_id: "2" },
  //           ],
  //         },
  //       ],
  //     },
  //   ], 
  // },
  // {
  //   state_id: "3",
  //   sortname: "UP",
  //   state_name: "UttarPradesh",
  //   budget: [
  //     {
  //       budgetNo: "1235789",
  //       Discription:
  //         "Uttar Pradesh is a state in northern India. With over 240 million inhabitants, it is the most populated state in India as well as the most populous country subdivision in the world. It was established in 1950 after India had become a republic. It was a successor to the United Provinces (UP) during the period of the ",
  //         image:"images/UP.png"
  //     },
    ],
  },
];
export default SectorData;